import './modules/notifications';
import './modules/dealCalendarDrawer';
import './modules/saveButtonSpinner';
import './modules/profileDrawerLoad';
import './modules/activityTrackerDrawer';
import './modules/drawerOverlayGuard';
import './modules/dealAccessPaywall';
import './modules/realtime';

window.lockBodyScroll = function(lock) {
  document.documentElement.style.overflow = lock ? 'hidden' : '';
  document.body.style.overflow = lock ? 'hidden' : '';
}

window.EMAIL_BROADCAST_MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;

window.validateEmailBroadcastAttachments = function (fileList) {
	if (!fileList || !fileList.length) {
		return { valid: true };
	}

	for (var i = 0; i < fileList.length; i++) {
		if (fileList[i].size > window.EMAIL_BROADCAST_MAX_ATTACHMENT_BYTES) {
			return {
				valid: false,
				message: 'Each attachment must be 10 MB or smaller. "' + fileList[i].name + '" is too large.',
			};
		}
	}

	return { valid: true };
};

window.getAjaxErrorMessage = function (xhr, fallback) {
	fallback = fallback || 'An error occurred. Please try again.';

	if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
		return xhr.responseJSON.message;
	}

	if (xhr && xhr.responseText) {
		try {
			var json = JSON.parse(xhr.responseText);
			if (json && json.message) {
				return json.message;
			}
		} catch (e) { /* ignore */ }
	}

	return fallback;
};

window.DYNAMIC_TAG_PATTERN = /\{\$[^}]+\}/g;

window.registerBroadcastDynamicTagBlot = function () {
	if (window.__broadcastDynamicTagBlotRegistered || typeof Quill === 'undefined') {
		return;
	}

	const Embed = Quill.import('blots/embed');

	class DynamicTagBlot extends Embed {
		static create(value) {
			const node = super.create();
			node.setAttribute('class', 'dynamic-tag');
			// Do not set contenteditable=false on the outer node — Quill Embed
			// uses ZWNBSP guards here; that attribute breaks click-after caret.
			node.setAttribute('data-tag', value);
			node.textContent = value;
			return node;
		}

		static value(node) {
			return node.getAttribute('data-tag') || (node.textContent || '').trim();
		}
	}

	DynamicTagBlot.blotName = 'dynamicTag';
	DynamicTagBlot.tagName = 'SPAN';

	Quill.register(DynamicTagBlot, true);
	window.__broadcastDynamicTagBlotRegistered = true;
};

window.insertDynamicTag = function (quill, index, text) {
	if (!quill || typeof quill.insertEmbed !== 'function') {
		return;
	}

	const source = (typeof Quill !== 'undefined' && Quill.sources && Quill.sources.USER)
		? Quill.sources.USER
		: 'user';

	quill.insertEmbed(index, 'dynamicTag', text, source);
};

window.styleDynamicTagsInQuill = function (quill) {
	if (!quill || typeof quill.getText !== 'function' || typeof quill.insertEmbed !== 'function') {
		return;
	}

	const source = (typeof Quill !== 'undefined' && Quill.sources && Quill.sources.SILENT)
		? Quill.sources.SILENT
		: 'silent';
	const text = quill.getText();
	const pattern = new RegExp(window.DYNAMIC_TAG_PATTERN.source, 'g');
	const matches = [];
	let match;

	while ((match = pattern.exec(text)) !== null) {
		matches.push({ index: match.index, value: match[0], length: match[0].length });
	}

	// Replace from end so earlier indexes stay valid.
	for (let i = matches.length - 1; i >= 0; i--) {
		const m = matches[i];
		quill.deleteText(m.index, m.length, source);
		quill.insertEmbed(m.index, 'dynamicTag', m.value, source);
	}
};

// Quill zeroes block margins inside .ql-editor; outbound HTML is unstyled <p> tags.
// Email clients apply default paragraph margins, so spacing looks looser than the editor.
window.normalizeQuillHtmlForEmail = function (html) {
	if (!html || typeof html !== 'string') {
		return '';
	}

	// Embed tags: prefer data-tag, then class + inner text.
	html = html.replace(/<span[^>]*\bdata-tag="(\{\$[^}"]+})"[^>]*>[\s\S]*?<\/span>/gi, '$1');
	html = html.replace(/<span[^>]*class="[^"]*dynamic-tag[^"]*"[^>]*>(\{\$[^}]+\})<\/span>/gi, '$1');

	var blockStyle = 'margin:0;padding:0;line-height:1.42;';

	return html.replace(/<(p|h[1-6])(\s[^>]*)?>/gi, function (match, tag, attrs) {
		attrs = attrs || '';

		if (/\bstyle\s*=/i.test(attrs)) {
			if (/\bmargin\s*:/i.test(attrs)) {
				return match;
			}

			return match.replace(/\bstyle\s*=\s*(["'])(.*?)\1/i, function (_, quote, styles) {
				var trimmed = styles.trim();
				var separator = trimmed !== '' && !trimmed.endsWith(';') ? ';' : '';

				return 'style=' + quote + styles + separator + blockStyle + quote;
			});
		}

		return '<' + tag + ' style="' + blockStyle + '"' + attrs + '>';
	});
};

window.blockElement = function(elementID) {

	var theBlockUI = KTBlockUI.getInstance(document.querySelector(elementID));
	if(!theBlockUI) {
		theBlockUI = new KTBlockUI(document.querySelector(elementID));
	}
	theBlockUI.options.message = '<span class="spinner-border text-primary"></span>';
	theBlockUI.block();
}

window.blockElementWithMsg = function(elementID, msg) {
	var theBlockUI = KTBlockUI.getInstance(document.querySelector(elementID));
	if(!theBlockUI) {
		theBlockUI = new KTBlockUI(document.querySelector(elementID));
	}
	theBlockUI.options.message = '<div class="blockui-message">' + msg + '</div>';
	theBlockUI.block();
}

window.releaseElement = function(elementID) {
	var theBlockUI = KTBlockUI.getInstance(document.querySelector(elementID));
	if(theBlockUI && theBlockUI.isBlocked()) {
		theBlockUI.release();
	}
}

function initTagifyOn(root = document) {
  root.querySelectorAll('.js-tagify:not(.tagify)').forEach(el => {
    if (el._tagify) return;
		el._tagify = new Tagify(el, {
			whitelist: window.allContactTags,
			maxTags: 30,
			dropdown: {
				position: "input",
				enabled: 0,
				maxItems: 99999999,
				closeOnSelect: false
			},
			callbacks: {
				add: function (e) {
					if (e.detail.data.value === 'Add New Tag +') {
						el._tagify.removeTag(e.detail.tag);
						Swal.fire({
							title: 'Create New Tag',
							input: 'text',
							showConfirmButton: true,
							showCloseButton: true,
							showCancelButton: true,
							focusConfirm: true,
							confirmButtonText: "Create",
							confirmButtonPosition: 'right',
							reverseButtons: true,
							customClass: {
								confirmButton: "btn fw-bold btn-primary",
								cancelButton: "btn fw-bold btn-active-light-primary"
							},
							preConfirm: (newTag) => {
								el._tagify.addTags(newTag);
							},
						});
					}
				},
			}
		});
		el._tagify.on('change', () => {
			const vals = el._tagify.value.map(v => v.value);
			Livewire.dispatch('tagify-updated', { value: vals });
		});
  });
}

document.addEventListener('DOMContentLoaded', () => {
	initTagifyOn(document);
	window.initSaveButtonSpinnerBindings();

	document.addEventListener('kt.drawer.shown', e => {
		initTagifyOn(e.target);
	});

	document.addEventListener('shown.bs.modal', e => {
		initTagifyOn(e.target);
	});
});

$( document ).ready(function() {

	$("#company_company_id").on("change", function(e) {
		window.checkCompanyCompanyId(this.value);
	});

	window.reloadMenus = function() {
		var i = 0;
		var interval = setInterval(function() {
			KTMenu.createInstances();
			i++;
			if(i == 10) {
				clearInterval(interval);
			}
		}, 500);

		KTMenu.createInstances();
	}


});

// On document ready
KTUtil.onDOMContentLoaded(function () {

	$('#kt_modal_create_deal').on('shown.bs.modal', function (e) {


		function formatCurrencyInput(input) {
			// Get the current input value
			var inputValue = $(input).val();
			// Remove the existing "$" if present
			var sanitizedValue = inputValue.replace(/^\$/, '');
			// Replace any non-numeric characters except for a single decimal point
			sanitizedValue = sanitizedValue.replace(/[^0-9.]/g, '');
			// Allow only one decimal point
			if (sanitizedValue.indexOf('.') !== sanitizedValue.lastIndexOf('.')) {
				sanitizedValue = sanitizedValue.slice(0, sanitizedValue.lastIndexOf('.'));
			}
			// Limit to two decimal places
			var decimalIndex = sanitizedValue.indexOf('.');
			if (decimalIndex !== -1) {
				sanitizedValue = sanitizedValue.slice(0, decimalIndex + 3);
			}
			// Split the integer and decimal parts
			var parts = sanitizedValue.split('.');
			var integerPart = parts[0];
			var decimalPart = parts[1] || '';
			// Format the integer part with commas
			var formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			// Concatenate the formatted integer part and decimal part with "$" prefix
			var formattedValue = '$' + formattedIntegerPart + (decimalIndex !== -1 ? '.' + decimalPart : '');
			return formattedValue;
		}

	// Delegated handler so currency inputs are sanitized even when added later (e.g. portfolio fields after switching to Portfolio Flow)
		$('#kt_modal_create_deal').on('input', '#create_deal_loan_amount, #price_per_sqft, #portfolio_property_price_per_sqft, #portfolio_property_loan_amount', function () {
			$(this).val(formatCurrencyInput($(this)));
		});

		window.initDealAutocomplete();
	});

    if(jQuery("#2fainputdiv").length) {
        jQuery("#code_1").on('input',function(e){
            jQuery("#code_2").focus();
        });
        jQuery("#code_2").on('input',function(e){
            jQuery("#code_3").focus();
        });
        jQuery("#code_3").on('input',function(e){
            jQuery("#code_4").focus();
        });
        jQuery("#code_4").on('input',function(e){
            jQuery("#code_5").focus();
        });
        jQuery("#code_5").on('input',function(e){
            jQuery("#code_6").focus();
        });
        jQuery("#code_6").on('input',function(e){
            
        });
    }

	if(("#to_call_contact_id").length) {
		$('#to_call_contact_id').select2({
			dropdownParent: $("#kt_modal_add_event"),
			minimumInputLength: 2,
			delay: 250,
			cache: true,
			dataType: 'json',
			ajax: {
				url: "/callfollowup/search",
				dataType: 'json'
			}
		});
	}

	jQuery("#followup_add_new").on("click", function() {

		$("#kt_modal_add_event").modal('show');
	
		var initialMessage = "Select Contact";
	
		var contactInfoBlock = new KTBlockUI(document.querySelector("#contact_info"), {
			message: '<div class="blockui-message">' + initialMessage + '</div>',
		});
	
		var contactNotesBlock = new KTBlockUI(document.querySelector("#contact_notes"), {
			message: '<div class="blockui-message">' + initialMessage + '</div>',
		});
	
		var contactSendEmailBlock = new KTBlockUI(document.querySelector("#contact_send_email"), {
			message: '<div class="blockui-message">' + initialMessage + '</div>',
		});
	
		var contactAssignDateBlock = new KTBlockUI(document.querySelector("#contact_assign_date"), {
			message: '<div class="blockui-message">' + initialMessage + '</div>',
		});
	
		if(contactInfoBlock) {
			contactInfoBlock.block();
		}
		contactNotesBlock.block();  
		contactSendEmailBlock.block();  
		contactAssignDateBlock.block();  
	
		jQuery("#select_contact_container").show();
	
	
		$('#to_call_contact_id').on("change", function(e) {
			var contactId = $('#to_call_contact_id').val(); 
			var csrf_token = $('meta[name="csrf-token"]').attr('content');
		
			var tmp = contactId.split("|");
			var type = tmp[0];
			var id = tmp[1];
	
			jQuery("#follow_up_type").val(type);
			jQuery("#follow_up_contact_id").val(id);
	
			$.ajax({
				type: "POST",
				url: "/callfollowup/details",
				data : { 
					_token: csrf_token, 
					contact_id: contactId
				},
				success: function (data) {
	
					jQuery("#contact_name").html("<a href='#' onClick='window.viewContact(event, " + data.id + ")'>" + data.first_name + ' ' + data.last_name + "</a>");
					jQuery("#contact_address").html(data.street + ' ' + data.city + ', ' + data.state + ' ' + data.zip);
					jQuery("#contact_type").html(data.type);
	
					if(data.phone) {
						jQuery("#contact_phone").html("<a onclick='window.contactPhoneNumberClick(event, " + contactId + ", " + JSON.stringify(String(data.phone)) + ");' href='#'>" + data.phone + "</a>");
					} else {
						jQuery("#contact_phone").hide();
					}
					if(data.email) {
						jQuery("#contact_email").html("<a href='mailto:" + data.email + "'>" + data.email + "</a>");
						jQuery("#compose_to").val(data.email);
					} else {
						jQuery("#contact_email").hide();
					}
	
					jQuery("#contact_note").html(data.note);
					jQuery("#contact_note_date").html(data.note_date);
					jQuery("#follow_up_date").val();
				},
			});
	
			if(contactInfoBlock) {
				contactInfoBlock.release();  
			}
			contactNotesBlock.release();
			contactSendEmailBlock.release();
			contactAssignDateBlock.release();
		});
	});

	jQuery("#followup_add_new_from_contact").on("click", function() {

		$("#kt_modal_add_event").modal('show');
		jQuery("#select_contact_container").show();
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		var contactId = $('#init_followup_contact_id').val();

		var tmp = contactId.split("|");
		var type = tmp[0];
		var id = tmp[1];

		jQuery("#follow_up_type").val(type);
		jQuery("#follow_up_contact_id").val(id);

		$.ajax({
			type: "POST",
			url: "/callfollowup/details",
			data : { 
				_token: csrf_token, 
				contact_id: contactId
			},
			success: function (data) {

				jQuery("#contact_name").html("<a href='#' onClick='window.viewContact(" + data.id + ")'>" + data.first_name + ' ' + data.last_name + "</a>");
				jQuery("#contact_address").html(data.street + ' ' + data.city + ', ' + data.state + ' ' + data.zip);
				jQuery("#contact_type").html(data.type);

				if(data.phone) {
					jQuery("#contact_phone").html("<a onclick='window.contactPhoneNumberClick(event, " + contactId + ", " + JSON.stringify(String(data.phone)) + ");' href='#'>" + data.phone + "</a>");
				} else {
					jQuery("#contact_phone").hide();
				}
				if(data.email) {
					jQuery("#contact_email").html("<a href='mailto:" + data.email + "'>" + data.email + "</a>");
					jQuery("#compose_to").val(data.email);
				} else {
					jQuery("#contact_email").hide();
				}

				jQuery("#contact_note").html(data.note);
				jQuery("#contact_note_date").html(data.note_date);
				jQuery("#follow_up_date").val();

				jQuery("#select_contact_container").hide();
			},
		});

	});
	
    jQuery("#followup_save").on("click", function(e) {

        var csrf_token = $('meta[name="csrf-token"]').attr('content');

        var theDate = jQuery("#follow_up_date").val();

        if(!theDate) {
            Swal.fire(
                'Follow Up Date Required',
                'Please select a follow up date to continue',
                'error'
            );
            return;
        }

        if(!jQuery("#follow_up_contact_id").val()) {

            var contactId = jQuery("#to_call_contact_id").val(); 

            if(!contactId) {
                Swal.fire(
                    'Contact Required',
                    'Please select a contact to continue',
                    'error'
                );
                return;
            }

            var tmp = contactId.split("|");
            var type = tmp[0];
            var id = tmp[1];

            jQuery("#follow_up_type").val(type);
            jQuery("#follow_up_contact_id").val(id);
        } else {
            var contactId = "contact|" + jQuery("#follow_up_contact_id").val();
        } 
        //======================================================
        // Check to see if we need to ADD or EDIT the follow up.
        //=======================================================
        if(jQuery("#follow_up_id").val() == "") {

            // Add the new follow up

            $.ajax({
                type: "POST",
                url: "/callfollowup/create",
                data : { 
                    _token: csrf_token, 
                    id: contactId,
                    follow_up_date: theDate,
                },
                success: function (data) {
					
					jQuery("#follow_up_id").val(data);
					location.reload();
                    
                },
            });

        } else {

            // Edit the follow up
            $.ajax({
                type: "POST",
                url: "/callfollowup/edit",
                data : { 
                    _token: csrf_token, 
                    id: contactId,
                    follow_up_date: theDate,
                    follow_up_id: jQuery("#follow_up_id").val(),
                },
                success: function (data) {
					
					jQuery("#follow_up_id").val(data);
					location.reload();
                    
                },
            });

        }
    });

    jQuery("#followup_send_email").on("click", function(e) {
        var csrf_token = $('meta[name="csrf-token"]').attr('content');

        $.ajax({
            type: "POST",
            url: "/callfollowup/send",
            data : { 
                _token: csrf_token, 
                to_email: jQuery("#compose_to").val(),
                contents: typeof window.normalizeQuillHtmlForEmail === 'function'
					? window.normalizeQuillHtmlForEmail(jQuery("#kt_inbox_form_editor > div").html())
					: jQuery("#kt_inbox_form_editor > div").html(),
                subject: jQuery("#compose_subject").val(),
            },
            success: function (data) {
                window.toastSuccess("Your Email was sent!");
            },
        });
    });

    jQuery("#contact_add_note_btn").on("click", function(e) {

        var csrf_token = $('meta[name="csrf-token"]').attr('content');
    
        var id = jQuery("#follow_up_contact_id").val();

        $.ajax({
            type: "POST",
            url: "/callfollowup/contact/addnote",
            data : { 
                _token: csrf_token, 
                id: id,
                new_note: jQuery("#contact_new_note_field").val(),
            },
            success: function (data) {
                jQuery("#contact_note").html(data.note);
                jQuery("#contact_note_date").html(data.note_date);
                jQuery("#contact_new_note_field").val("");

				window.toastSuccess("Your note was successfully added!");
            },
        });
    });

	window.initQuillFollowup = false;

	window.doInitFollowUp = function() {
		if($("#kt_inbox_form_editor").length) {
			if(window.initQuillFollowup === false) {
				var quill = new Quill('#kt_inbox_form_editor', {
					modules: {
						toolbar: [
							[{
								header: [1, 2, false]
							}],
							['bold', 'italic', 'underline'],
							['image', 'code-block']
						]
					},
					placeholder: '',
					theme: 'snow' // or 'bubble'
				});

				window.initQuillFollowup = true;

			}
		}

		if($("#follow_up_date").length) {
			const flatpickr = require('flatpickr');
			var dueDate = $("#follow_up_date");
			dueDate.flatpickr({
				enableTime: false,
				dateFormat: "m/d/Y",
			});
		}
	}

	window.doInitFollowUp();

	// Align with the browser’s type=email rules (more forgiving than a hand-rolled strict regex).
	window.isValidContactEmailFormat = function (email) {
		if (!email || typeof email !== 'string') {
			return false;
		}
		var trimmed = email.trim();
		if (trimmed === '') {
			return false;
		}
		var probe = document.createElement('input');
		probe.type = 'email';
		probe.value = trimmed;
		return typeof probe.checkValidity === 'function' ? probe.checkValidity() : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
	};

	$("#contact_create_email").on("change", function() {
		window.checkContactEmailAndPhone();
	});

	$("#contact_create_phone").on("change", function() {
		window.checkContactEmailAndPhone();
	});

	window.checkContactEmailAndPhone = function() {

		var theEmail = $("#contact_create_email").val();
		var thePhone = $("#contact_create_phone").val();

		$('#contact_create_email_format_invalid').addClass('d-none');

		if (theEmail && String(theEmail).trim() !== '' && !window.isValidContactEmailFormat(theEmail)) {
			jQuery('.contact_create_email_error').hide();
			$('#contact_create_email_format_invalid').removeClass('d-none');
			window.enableAddContactForm();
			return;
		}

		if(theEmail == "") {
			theEmail = "null";
		}

		if(thePhone == "") {
			thePhone = "null";
		}
		
		$.ajax({
			type: "GET",
			url: "/contacts/check/email/" + theEmail + "/phone/" + thePhone,      
			success: function (data) {

				if(data.emailExists) {
					window.disableAddContactForm();
					jQuery(".contact_create_email_error").show();
					$("#existingContactOwner").html(data.assignedUserHtml);
				} else {
					jQuery(".contact_create_email_error").hide();
					$("#existingContactOwner").html(data.assignedUserHtml);
				}

				if(data.phoneExists) {
					window.disableAddContactForm();
					jQuery(".contact_create_phone_error").show();
					$("#existingContactOwner").html(data.assignedUserHtml);
				} else {
					jQuery(".contact_create_phone_error").hide();
					$("#existingContactOwner").html(data.assignedUserHtml);
				}

				if(!data.emailExists && !data.phoneExists) {
					window.enableAddContactForm();
				}
			},
			error: function () {
				window.enableAddContactForm();
			},
		});

	}

	window.checkCompanyCompanyId = function(companyCompanyId, companyId) {
		// Confirm it's a number first.
		if (isNaN(companyCompanyId)) {
			window.disableCompanyForm();
			jQuery(".company_company_id_error_nan").show();
			return;
		}
		else {
			window.enableCompanyForm();
			jQuery(".company_company_id_error_nan").hide();
		}

		let url = "/companies/check/company-id/" + companyCompanyId;
		if (typeof(companyId) !== 'undefined' && companyId !== '') {
			url += '/' + companyId;
		}

		$.ajax({
			type: "GET",
			url: url,
			success: function (data) {

				if(data.companyCompanyIdExists) {
					window.disableCompanyForm();
					jQuery(".company_company_id_error").show();
				} else {
					jQuery(".company_company_id_error").hide();
				}

				if(!data.companyCompanyIdExists) {
					window.enableCompanyForm();
				}
			}
		});

	}

	window.disableCompanyForm = function() {
		if ($('#kt_modal_add_company_submit').length > 0) {
			$("#kt_modal_add_company_submit").attr("disabled", "true");
		}
		if ($('#company_profile_save').length > 0) {
			$("#company_profile_save").attr("disabled", "true");
		}
	}

	window.enableCompanyForm = function() {
		if ($('#kt_modal_add_company_submit').length > 0) {
			$("#kt_modal_add_company_submit").removeAttr("disabled");
		}
		if ($('#company_profile_save').length > 0) {
			$("#company_profile_save").removeAttr("disabled");
		}
	}

	window.disableAddContactForm = function() {
		jQuery("#kt_modal_add_contact_submit").attr("disabled", "true");
	}

	window.enableAddContactForm = function() {
		jQuery("#kt_modal_add_contact_submit").removeAttr("disabled");
	}

	window.__addContactCompanyPayload = window.__addContactCompanyPayload || { id: '', name: '' };

	function getAddContactSelectValue(id) {
		var el = document.getElementById(id);
		if (!el) {
			return '';
		}
		if (el.tagName === 'UI-SELECT') {
			if (el.value !== undefined && el.value !== null && el.value !== '') {
				return String(el.value);
			}
			return '';
		}
		return $(el).val() ? String($(el).val()) : '';
	}

	function clearAddContactFluxSelect(id) {
		var el = document.getElementById(id);
		if (el && el.tagName === 'UI-SELECT' && typeof el.clear === 'function') {
			el.clear();
		}
	}

	window.resetAddContactModalValues = function() {
		$("#kt_modal_add_contact").modal("hide");
		$("#contact_create_first_name").val(""); 
		$("#contact_create_last_name").val(""); 
		clearAddContactFluxSelect('contact_create_type_id');
		clearAddContactFluxSelect('contact_create_market_type_id');
		clearAddContactFluxSelect('contact_create_lead_status_id');
		if (typeof Livewire !== 'undefined') {
			Livewire.dispatch('reset-add-contact-company-select');
		}
		window.__addContactCompanyPayload = { id: '', name: '' };
		$("#contact_create_title").val("");
		$("#contact_create_email").val("");
		$('#contact_create_email_format_invalid').addClass('d-none');
		$("#contact_create_phone").val("");
		$("#contact_create_street").val("");
		$("#contact_create_city").val("");
		$("#contact_create_state").val("");
		$("#contact_create_zip").val("");
		$("#contact_create_group_ids").val("");
		$("#contact_create_tags").val("");
		$("#contact_note").val("");
		window.enableAddContactForm();
	}

	$("#kt_modal_add_contact_cancel").on("click", function() {
		$("#kt_modal_add_contact").modal("hide");
		window.resetAddContactModalValues();
	});

	$("#kt_modal_add_contact_submit").on("click", function(e) {
		e.preventDefault();

		let button = this;
		var isValid = true;

		if($("#contact_create_first_name").val() == "") {
			isValid = false;
		}

		if($("#contact_create_last_name").val() == "") {
			isValid = false;
		}

		if(getAddContactSelectValue('contact_create_type_id') == "") {
			isValid = false;
		}

		var emailVal = $("#contact_create_email").val();
		if(emailVal == "") {
			isValid = false;
		} else if (!window.isValidContactEmailFormat(emailVal)) {
			isValid = false;
		}

		if(isValid) {
			window.addSpinnerToButton(button);
			var csrf_token = $('meta[name="csrf-token"]').attr('content');

			$.ajax({
				type: "POST",
				url: "/contacts/add",
				data : { 
					_token: csrf_token, 
					first_name: $("#contact_create_first_name").val(), 
					last_name: $("#contact_create_last_name").val(), 
					type_id: getAddContactSelectValue('contact_create_type_id'),
					company_id: (window.__addContactCompanyPayload && window.__addContactCompanyPayload.id) ? window.__addContactCompanyPayload.id : '',
					company_name: (window.__addContactCompanyPayload && window.__addContactCompanyPayload.name) ? window.__addContactCompanyPayload.name : '',
					title: $("#contact_create_title").val(),
					email: $("#contact_create_email").val(),
					phone: $("#contact_create_phone").val(),
					street: $("#contact_create_street").val(),
					city: $("#contact_create_city").val(),
					state: $("#contact_create_state").val(),
					zip: $("#contact_create_zip").val(),
					group_ids: $("#contact_create_group_ids").val(),
					tags: $("#contact_create_tag_ids").val(),
					note: $("#contact_create_note").val(),
					market_type_id: getAddContactSelectValue('contact_create_market_type_id'),
					lead_status_id: getAddContactSelectValue('contact_create_lead_status_id'),
				},
	
				success: function (data) {
					window.toastSuccess("New Contact Created!");
					Livewire.dispatch('refreshDashboardStats');
					$("#kt_modal_add_contact").modal("hide");
					window.removeSpinnerFromButton(button, 'Submit');
					window.resetAddContactModalValues();
					if (window.contactsDataTable) {
						window.contactsDataTable.ajax.reload(null, false);
					}
				},
				error: function (data, textStatus, errorThrown) {
					window.removeSpinnerFromButton(button, 'Submit');
					window.toastError("An error occurred. please try again.");
				},
			});
		} else {
			window.removeSpinnerFromButton(button, 'Submit');
			var emailForMsg = $("#contact_create_email").val();
			var swalText = "Please fill in all required fields.";
			if (emailForMsg !== "" && !window.isValidContactEmailFormat(emailForMsg)) {
				swalText = "Please enter a valid email address.";
			}
			Swal.fire({
				text: swalText,
				icon: "error",
				buttonsStyling: false,
				confirmButtonText: "Ok",
				customClass: {
					confirmButton: "btn fw-bold btn-darkblue",
				}
			});
		}

		
	});

	window.addContactTags = new Tagify(document.querySelector("#contact_create_tag_ids"), {
		whitelist: window.allContactTags,
		maxTags: 30,
		dropdown: {
			position: "input",
			enabled: 0,
			maxItems: 99999999,
			closeOnSelect: false
		}
	});

	window.addContactGroups = new Tagify(document.querySelector("#contact_create_group_ids"), {
		whitelist: window.contactGroupOptions,
		tagTextProp: "name",
		enforceWhitelist: true,
		dropdown: {
			position: "input",
			enabled: 0,
			maxItems: 99999999,
			closeOnSelect: false,
			mapValueTo: "name",
			searchKeys: ["name"]
		}
	});

	$("#kt_modal_add_company_cancel").on("click", function() {
		jQuery("#kt_modal_new_company").modal('hide');
	});

	$("#kt_modal_add_company_submit").on("click", function() {
		// Add spinner and disable button.
		let button = this
		window.addSpinnerToButton(button);

		var csrf_token = $('meta[name="csrf-token"]').attr('content');

		$.ajax({
			type: "POST",
			url: "/companies/add",
			data : { 
				_token: csrf_token, 
				name: $("#create_company_name").val(),
				phone: $("#create_company_phone").val(),
				email: $("#create_company_email").val(),
				address: $("#create_company_address").val(),
				city: $("#create_company_city").val(),
				state: $("#create_company_state").val(),
				zip: $("#create_company_zip").val(),
				type_ids: $("#create_company_type_id").val(),
				company_id: $("#company_company_id").val(),
			},

			success: function (data) {
				window.toastSuccess("New Company Created!");
				jQuery("#kt_modal_new_company").modal('hide');
				window.removeSpinnerFromButton(button, 'Submit');

				if (window.companiesDataTable) {
					window.companiesDataTable.ajax.reload(null, false);
				}
			},
			error: function (data, textStatus, errorThrown) {
				window.removeSpinnerFromButton(button, 'Submit');
				window.toastError("An error occurred. please try again.");
			},
		});
	});

	window.reloadCreateContact = false;

	$("#kt_modal_new_company").on("hidden.bs.modal", function() {
		if(window.reloadCreateContact) {
			jQuery("#kt_modal_add_contact").modal('show');
			window.reloadCreateContact = false;
		}
	});

	window.setNewContactCompany = function(id, name) {
		if (typeof Livewire !== 'undefined') {
			Livewire.dispatch('set-add-contact-company', { id: id, name: name || '' });
		}
	};

	// Bootstrap 5 modal focus trap conflicts with Select2 / Flux listbox inside the add-contact modal.
	$(document).on('focusin.addContactModalSelect2', function (e) {
		if (!$('#kt_modal_add_contact').hasClass('show')) {
			return;
		}
		if ($(e.target).closest('.select2-container, [data-flux-select]').length) {
			e.stopImmediatePropagation();
		}
	});

	if (typeof Livewire !== 'undefined') {
		Livewire.on('add-contact-open-new-company', function (payload) {
			var name = '';
			if (payload && typeof payload.name === 'string') {
				name = payload.name;
			}
			$('#kt_modal_add_contact').modal('hide');
			$('#kt_modal_new_company').modal('show');
			$('#create_company_name').val(name);
			window.reloadCreateContact = true;
		});
	}

    $('#kt_modal_add_contact').on('shown.bs.modal', function () {
		window.enableAddContactForm();
		window.initCreateContactAutocomplete();
		if (typeof Livewire !== 'undefined') {
			Livewire.dispatch('reset-add-contact-company-select');
		}
		window.phoneFormatter("#contact_create_phone");
		// Property map listing-broker "Add Contact" prefill (applied after company reset above).
		if (typeof window.applyPendingAddContactPrefill === 'function' && window.pendingAddContactPrefill) {
			setTimeout(function () {
				window.applyPendingAddContactPrefill();
			}, 50);
		}
    });

	window.initCreateNewPortfolioAutocomplete = function(id) {
		var element = document.getElementById('portfolio_street_line_one');
		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setCreateNewPortfolioAddress);
		}
	}

	window.setCreateNewPortfolioAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var county = '';
		var street_number = '';
		var route = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];
			for (var j in component.types) {  // Some types are ["country", "political"]
				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'administrative_area_level_2':
						county = component.short_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}

		// Remove the " County" from the county name
		if (typeof county === 'string' && county.toLowerCase().endsWith(' county')) {
			county = county.slice(0, -7).trim();
		}
		
		var addressData = {
			'street_line_one': street_number + ' ' + route,
			'city': city,
			'state': state,
			'zip_code': zipcode,
			'county': county
		};

		Livewire.dispatch('setPortfolioAddress', { data: addressData });

	}

	window.initCreateNewDealAutocomplete = function() {
		var element = document.getElementById('property_street_line_one');
		if (!element) {
			return;
		}

		// Only initialize if Google Maps Places API is loaded
		if (window.google && google.maps && google.maps.places && google.maps.places.Autocomplete) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setCreateNewDealAddress);
			return;
		}

		// Retry a few times in case the Maps script hasn't loaded yet
		window._initCreateNewDealAttempts = (window._initCreateNewDealAttempts || 0) + 1;
		if (window._initCreateNewDealAttempts < 6) {
			setTimeout(function() {
				window.initCreateNewDealAutocomplete();
			}, 500);
		} else {
			console.warn('Google Maps Places API not available - autocomplete not initialized for #property_street_line_one');
		}
	}

	window.setCreateNewDealAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var street_number = '';
		var county = '';
		var route = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];

			for (var j in component.types) {  // Some types are ["country", "political"]

				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'administrative_area_level_2':
						county = component.short_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}

		// Remove the " County" from the county name
		if (typeof county === 'string' && county.toLowerCase().endsWith(' county')) {
			county = county.slice(0, -7).trim();
		}

		var addressData = {
			'street_line_one': street_number + ' ' + route,
			'city': city,
			'state': state,
			'zip_code': zipcode,
			'county' : county
		};

		Livewire.dispatch('setDealAddress', { data: addressData });
	}


	window.initDealAutocomplete = function(id) {
		var element = document.getElementById('street_line_one');
		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setCreateDealAddress);
		}
	}

	window.setCreateDealAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var street_number = '';
		var route = '';
		var county = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];
			for (var j in component.types) {  // Some types are ["country", "political"]
				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'administrative_area_level_2':
						county = component.long_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}

		$("#street_line_one").val(street_number + ' ' + route);
		$("#city").val(city);
		$("#state").val(state).change();
		$("#zip_code").val(zipcode);

		// Remove the " County" from the county name
		if (typeof county === 'string' && county.toLowerCase().endsWith(' county')) {
			county = county.slice(0, -7).trim();
		}

		$("#county").val(county);

	}


	
	window.initCreateContactAutocomplete = function(id) {
		var element = document.getElementById('contact_create_street');
		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setCreateContactAddress);
		}
	}

	window.setCreateContactAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var street_number = '';
		var route = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];
			for (var j in component.types) {  // Some types are ["country", "political"]
				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}

		$("#contact_create_street").val(street_number + ' ' + route);
		$("#contact_create_city").val(city);
		$("#contact_create_state").val(state).change();
		$("#contact_create_zip").val(zipcode);

	}

	$('#kt_modal_new_company').on('show.bs.modal', function (e) {
		$("#create_company_name").val("");
		$("#create_company_phone").val("");
		$("#create_company_email").val("");
		$("#create_company_address").val("");
		$("#create_company_city").val("");
		$("#create_company_state").val("");
		$("#create_company_zip").val("");
		$("#create_company_type_id").val("");
	});

	$('#kt_modal_new_company').on('shown.bs.modal', function (e) {
		window.initCreateCompanyAutocomplete();
		window.phoneFormatter("#create_company_phone");

		jQuery("#create_company_type_id").select2({
			dropdownParent: jQuery("#kt_modal_new_company"),
			multiple: true,
			placeholder: 'Select Company Types',
		});
	});
	
	window.initCreateCompanyAutocomplete = function(id) {
		var element = document.getElementById('create_company_address');
		if (element) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setCreateCompanyAddress);
		}
	}

	window.setCreateCompanyAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var street_number = '';
		var route = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];
			for (var j in component.types) {  // Some types are ["country", "political"]
				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}

		$("#create_company_address").val(street_number + ' ' + route);
		$("#create_company_city").val(city);
		$("#create_company_state").val(state).change();
		$("#create_company_zip").val(zipcode);

	}

	window.initViewCompanyAutocomplete = function(id) {
		var element = document.getElementById('company_street_address');
		if (!element) {
			return;
		}

		// Avoid attaching a second Autocomplete instance if the settings
		// tab is shown more than once without the drawer contents reloading.
		if (element.dataset.placesAutocompleteInitialized === 'true') {
			return;
		}

		// Only initialize if the Google Maps Places API is loaded
		if (window.google && google.maps && google.maps.places && google.maps.places.Autocomplete) {
			var autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
			google.maps.event.addListener(autocomplete, 'place_changed', window.setViewCompanyAddress);
			element.dataset.placesAutocompleteInitialized = 'true';
			return;
		}

		// Retry a few times in case the Maps script hasn't loaded yet
		window._initViewCompanyAutocompleteAttempts = (window._initViewCompanyAutocompleteAttempts || 0) + 1;
		if (window._initViewCompanyAutocompleteAttempts < 6) {
			setTimeout(function() {
				window.initViewCompanyAutocomplete();
			}, 500);
		} else {
			console.warn('Google Maps Places API not available - autocomplete not initialized for #company_street_address');
		}
	}

	window.setViewCompanyAddress = function() {
		var place = this.getPlace();

		var city = '';
		var state = '';
		var zipcode = '';
		var street_number = '';
		var route = '';

		for (var i in place.address_components) {
			var component = place.address_components[i];
			for (var j in component.types) {  // Some types are ["country", "political"]
				switch(component.types[j]) {
					case 'street_number':
						street_number = component.long_name;
						break;
					case 'route':
						route = component.long_name;
						break;
					case 'locality':
						city = component.long_name;
						break;
					case 'administrative_area_level_1':
						state = component.short_name;
						break;
					case 'postal_code':
						zipcode = component.long_name;
						break;
				}
			}
		}
		$("#company_street_address").val(street_number + ' ' + route);
		$("#company_city").val(city);
		$("#company_state").val(state).change();
		$("#company_zip").val(zipcode);
	}

	window.initAllMenus = function() {
		KTMenu.createInstances();
	}

	window.phoneFormatter = function(selector) {
		$(selector).on('input', function() {
			var input = $(this).val().replace(/\D/g, '');
			if (input.length > 10) {
				input = input.substring(0, 10);
			}
			if (input.length > 6) {
				input = input.replace(/(\d{3})(\d{3})(\d{1,4})/, '$1-$2-$3');
			} else if (input.length > 3) {
				input = input.replace(/(\d{3})(\d{1,3})/, '$1-$2');
			}
			$(this).val(input);
		});
	};

	window.showAdvancedSerach = function() {
        const dropdown = document.getElementById('advancedSearchMenu');
        dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
    }

	document.addEventListener('keydown', function(event) {
		if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
			const target = event.target;
			const isTypingTarget = target instanceof HTMLElement && (
				target.tagName === 'INPUT' ||
				target.tagName === 'TEXTAREA' ||
				target.isContentEditable
			);

			if (isTypingTarget && target.id === 'headerSearchInput') {
				return;
			}

			event.preventDefault();

			const searchInput = document.getElementById('headerSearchInput');
			if (!searchInput) {
				return;
			}

			searchInput.focus();
			searchInput.select();
			Livewire.dispatch('showRecentSearchDropdown');
		}
	});

    // Close the dropdown if the user clicks outside of it
    window.onclick = function(event) {
        if (!event.target.matches('.gear-icon') && !event.target.closest('.header-search-settings-toggle')) {
            const dropdowns = document.getElementsByClassName("dropdown-menu");
            for (let i = 0; i < dropdowns.length; i++) {
                let openDropdown = dropdowns[i];
                if (openDropdown.style.display === 'block') {
                    openDropdown.style.display = 'none';
                }
            }
        }

		const searchInput = document.getElementById('headerSearchInput');
		const searchRoot = searchInput ? searchInput.closest('.form-group') : null;

		if (searchRoot && !searchRoot.contains(event.target)) {
			Livewire.dispatch('hideSearchResults');
		}
	}

	window.toastUpdateContactSuccess = function(message) {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-right",
			"preventDuplicates": true,
			"onclick": null,
			"showDuration": "1500",
			"hideDuration": "1500",
			"timeOut": "1500",
			"extendedTimeOut": "10000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut",
			"toastClass": "toastUpdateContactSuccess",
		}

		var msg = `<table>
			<tbody>
				<tr>
					<td>
						<div class="symbol symbol-50px symbol-circle" data-bs-toggle="tooltip" title="" data-bs-original-title="test test">
							<span class="symbol-label bg-lightpurple text-inverse-warning fw-bolder">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-vcard" viewBox="0 0 16 16">
									<path d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8m1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"/>
									<path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96q.04-.245.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 1 1 12z"/>
								</svg>
							</span>
						</div>					
					</td>
					<td>
						` + message + `		  				
					</td>
				</tr>
			</tbody>
		</table>`;

		toastr.success(msg);
	}

	window.toastSuccess = function(message) {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-right",
			"preventDuplicates": true,
			"onclick": null,
			"showDuration": "1500",
			"hideDuration": "1500",
			"timeOut": "1500",
			"extendedTimeOut": "10000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut",
			"toastClass": "doSuccess",
		}
		  
		var msg = `<table>
			<tr>
				<td>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
						<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
						<path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
					</svg>
				</td>
				<td>
					` + message + `		  				
				</td>
			</tr>
		</table>`;

		toastr.success(msg);
	}

	if(window.theMessage != "") {
		if(window.theMessage !== undefined) {
			window.toastSuccess(window.theMessage);
		}
	}

	window.toastAlert = function(message) {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-right",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "1500",
			"hideDuration": "1500",
			"timeOut": "1500",
			"extendedTimeOut": "10000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut",
			"toastClass": "doAlert",
		}
		  
		var msg = `<table>
			<tr>
				<td>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bell-fill" viewBox="0 0 16 16">
						<path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2m.995-14.901a1 1 0 1 0-1.99 0A5 5 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901"/>
					</svg>
				</td>
				<td>
					` + message + `		  				
				</td>
			</tr>
		</table>`;

		toastr.success(msg);
	}

	window.toastError = function(message) {
		toastr.options = {
			"closeButton": false,
			"debug": false,
			"newestOnTop": false,
			"progressBar": false,
			"positionClass": "toast-top-right",
			"preventDuplicates": true,
			"showDuration": "1500",
			"hideDuration": "1500",
			"timeOut": "1500",
			"extendedTimeOut": "10000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}

		var msg = `<table style='width:100%;'><tr><td style='width:48px;vertical-align:middle;text-align:center;'>
			<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' fill='none' viewBox='0 0 32 32' style='cursor:pointer;' onclick='$(this).closest(".toast").remove();'>
				<circle cx='16' cy='16' r='15' stroke='#D53B42' stroke-width='2' fill='white'/>
				<path d='M10 10l12 12M22 10L10 22' stroke='#D53B42' stroke-width='2' stroke-linecap='round'/>
			</svg>
		</td>
		<td style='padding-left:12px;vertical-align:middle;color:#7E8396;font-size:18px;'>` + message + `</td></tr></table>`;
		toastr.error(msg);
	}

	if(window.theErrorMessage != "") {
		if(window.theErrorMessage !== undefined) {
			window.toastError(window.theErrorMessage);
		}
	}

	if (window.theAlertMessage != "" && window.theAlertMessage !== undefined) {
		window.toastAlert(window.theAlertMessage);
	}


	jQuery(".dataTables_filter label").each(function() {
		jQuery(this).contents().filter(function() { return this.nodeType === 3; }).remove();
	});


	jQuery(".dataTables_filter input").each(function() {
		jQuery(this).removeClass('form-control-sm')
			.addClass('form-control form-control-solid form-control-lg w-250px ps-15') // Add the custom class
			.wrap('<div class="d-flex align-items-center position-relative my-1"></div>') // Wrap input with a div for styling
			.attr("placeholder", "Search...") // Add placeholder
			.before(`<span class="svg-icon svg-icon-1 position-absolute ms-6">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
							<rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"></rect>
							<path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"></path>
						</svg>
					</span>`); // Add icon

	});

	jQuery(".dataTables_filter").each(function(index) {
		const incrementClass = `dataTables_filter_${index + 1}`;
		jQuery(this).addClass(incrementClass);

		const targetWrapper = `.setting-top-wrapper-${index + 1}`;
		jQuery(targetWrapper).append(jQuery(this));
	});

	window.activeContactTab = "overview";

	let savedScrollY = 0;

	window.contactDrawerElement = document.querySelector("#kt_drawer_view_contact");
	window.contactDrawer = KTDrawer.getInstance(window.contactDrawerElement);

	document.querySelectorAll('[data-kt-drawer]').forEach(function(drawerEl) {
		const drawerInstance = KTDrawer.getInstance(drawerEl);

		if (!drawerInstance || typeof window.KTEventHandler === 'undefined') return;

		// Listen for native events
		drawerInstance.on("kt.drawer.shown", () => {
			updateBodyScrollLock();
		});

		// MutationObserver fallback (overlay click)
		const observer = new MutationObserver(() => {
			updateBodyScrollLock();
		});

		observer.observe(drawerEl, {
			attributes: true,
			attributeFilter: ['class']
		});
	});

	if (window.contactDrawer && typeof window.KTEventHandler !== 'undefined') {
		window.contactDrawer.on("kt.drawer.shown", function() {
			updateBodyScrollLock();

		});

		window.contactDrawer.on("kt.drawer.after.hidden", function() {
			if (window.App && window.App.profileDrawer) {
				window.App.profileDrawer.resetOnHidden({
					storeKey: 'contactProfile',
					contentsSelector: '#contact_profile_contents',
					loadingSelector: '#contact_profile_loading',
					resetChrome: function () {
						window.App.profileDrawer.resetContactChrome();
					},
				});
			}
			updateBodyScrollLock();
		});
	}

	window.initCompanyTypeSelect2 = function() {
		var $companyType = $('#company_type_ids');
		if (!$companyType.length) {
			return;
		}

		if ($companyType.hasClass('select2-hidden-accessible')) {
			$companyType.select2('destroy');
		}

		function syncCompanyTypeSelect2ToJson() {
			var data = $companyType.select2('data') || [];
			var arr = data.map(function(d) { return { value: d.id }; });
			$('#company_type_ids_json').val(JSON.stringify(arr));
		}

		function renderCompanyTypeSelect2Outside() {
			var data = $companyType.select2('data') || [];
			var html = data.map(function(d) {
				return '<span class="badge badge-light badge-drawer-tag me-1 mb-1 fw-normal" data-tag-value="' + $('<div>').text(d.id).html() + '">' + $('<div>').text(d.text).html() + ' <span class="drawer-tag-remove ms-1" role="button" aria-label="Remove">&times;</span></span>';
			}).join('');
			$('#company_type_ids_outside').html(html || '');
			window.App?.companyProfile?.renderTypeChips?.(data);
		}

		var companyTypeVal = ($companyType.attr('data-initial') || '').split(',').map(function(t) { return t.trim(); }).filter(Boolean);

		$companyType.select2({
			width: '100%',
			allowClear: true,
			multiple: true,
			closeOnSelect: false,
			data: window.companyTypes.map(function(type) { return { id: type.id, text: type.value }; }),
			placeholder: 'Select Company Types',
			// Hide selected tags inside the Select2 field itself by customizing templateSelection
			templateSelection: function (data, container) {
				// Only show the placeholder if nothing is selected
				if (data.length === 0 || (data.length === 1 && !data[0].id)) {
					return $('<span>').text('Select Company Types');
				}
				// Return empty string to hide tags inside select2
				return $('<span>');
			}
		}).val(companyTypeVal).trigger('change');

		$companyType.off('change.syncCompanyTypeJson').on('change.syncCompanyTypeJson', function() {
			syncCompanyTypeSelect2ToJson();
			renderCompanyTypeSelect2Outside();
		});


		// Hide the select2 rendered selected tags using CSS as an additional fallback
		const hideSelect2TagStyleId = 'custom-hide-select2-tags-style';
		if (!document.getElementById(hideSelect2TagStyleId)) {
			const style = document.createElement('style');
			style.id = hideSelect2TagStyleId;
			style.innerHTML = `
				#company_type_ids + .select2 .select2-selection__rendered .select2-selection__choice {
					display: none !important;
				}
			`;
			document.head.appendChild(style);
		}


		syncCompanyTypeSelect2ToJson();
		renderCompanyTypeSelect2Outside();
	}

	// Same root cause as useFixedCompanyDealmatchDropdown above: the drawer scroll lock pins
	// <body> with position:fixed and a negative top, so Flatpickr's default positioning (which
	// adds window.pageYOffset to the input's viewport-relative getBoundingClientRect()) lands
	// off-screen once the underlying page has been scrolled before the drawer opened. Position
	// the calendar with fixed, viewport-relative coordinates instead.
	function positionFlatpickrFixed(instance, customPositionElement) {
		var calendar = instance.calendarContainer;
		var input = customPositionElement || instance._positionElement;
		if (!calendar || !input) {
			return;
		}
		var rect = input.getBoundingClientRect();
		var calendarHeight = Array.prototype.reduce.call(calendar.children, function (acc, child) {
			return acc + child.offsetHeight;
		}, 0);
		var viewportHeight = window.innerHeight;
		var showOnTop = viewportHeight - rect.bottom < calendarHeight && rect.top > calendarHeight;
		var top = showOnTop ? rect.top - calendarHeight - 2 : rect.bottom + 2;

		calendar.classList.toggle('arrowTop', !showOnTop);
		calendar.classList.toggle('arrowBottom', showOnTop);

		calendar.style.cssText = 'position: fixed; top: ' + top + 'px; left: ' + rect.left + 'px; right: auto;';
	}

	window.positionFlatpickrFixed = positionFlatpickrFixed;

	window.initCompanyDrawerOverviewFields = function() {
		if ($('#company_phone').length && typeof window.phoneFormatter === 'function') {
			window.phoneFormatter("#company_phone");
		}

		var followUpEl = document.getElementById('company_follow_up_date');
		if (followUpEl && !followUpEl._flatpickr) {
			followUpEl.removeAttribute('readonly');
			$(followUpEl).flatpickr({
				enableTime: false,
				dateFormat: "m/d/Y",
				allowInput: true,
				position: positionFlatpickrFixed,
			});
		}

		if (typeof window.initCompanyTypeSelect2 === 'function') {
			window.initCompanyTypeSelect2();
		}

		window.App?.companyOwner?.init?.();
		window.App?.companyProfile?.init?.();
	}

	/*
	|--------------------------------------------------------------------------
	| Global scroll-lock controller
	|--------------------------------------------------------------------------
	| ALWAYS checks if ANY drawer is open, not just the last one.
	| This prevents conflicts when multiple drawers exist.
	|--------------------------------------------------------------------------
	*/

	function isStackingPlanTenantDrawerElement(el) {
		return el && (el.id === 'stacking_plan_tenant_drawer' || el.getAttribute('data-stacking-plan-drawer') === 'true');
	}

	function shouldLockBodyForDrawers() {
		const openDrawers = document.querySelectorAll('.drawer-on');

		for (let i = 0; i < openDrawers.length; i++) {
			if (!isStackingPlanTenantDrawerElement(openDrawers[i])) {
				return true;
			}
		}

		return false;
	}

	function updateBodyScrollLock() {
		const shouldLock = shouldLockBodyForDrawers();
		const wasLocked = document.body.classList.contains('drawer-open');
		const modalOpen = document.querySelector('.modal.show') !== null;

		if (shouldLock) {
			// Save scroll position once
			if (!wasLocked) {
				savedScrollY = window.scrollY;
			}

			document.body.classList.add('drawer-open');
			// Do not stack position:fixed on body while a Bootstrap modal is open — it fights
			// modal-open / padding and Flux listbox (popover) focus layers; deal page often has
			// contact drawer + task modal together.
			if (!modalOpen) {
				document.body.style.position = 'fixed';
				document.body.style.top = `-${savedScrollY}px`;
				document.body.style.width = '100%';
			} else {
				document.body.style.position = '';
				document.body.style.top = '';
				document.body.style.width = '';
			}

		} else if (wasLocked) {
			// Unlock scroll
			document.body.style.position = '';
			document.body.style.top = '';
			document.body.style.width = '';
			document.body.classList.remove('drawer-open');

			// Restore scroll
			window.scrollTo(0, savedScrollY);
		}

	}

	window.updateBodyScrollLock = updateBodyScrollLock;

	$(document).on('shown.bs.modal hidden.bs.modal', '.modal', function () {
		updateBodyScrollLock();
	});




	window.currentContactID = 0;

	window.scrollToTop = true;

	window.activeCompanyTab = "overview";

	window.companyDrawerElement = document.querySelector("#kt_drawer_view_company");
	window.companyDrawer = KTDrawer.getInstance(window.companyDrawerElement);

	if (window.companyDrawer) {

		window.companyDrawer.on("kt.drawer.after.hidden", function() {
			if (window.App && window.App.profileDrawer) {
				window.App.profileDrawer.resetOnHidden({
					storeKey: 'companyProfile',
					contentsSelector: '#company_profile_contents',
					loadingSelector: '#company_profile_loading',
					resetChrome: function () {
						window.App.profileDrawer.resetCompanyChrome();
					},
					onHidden: function () {
						if (typeof window.destroyCompanyDealmatchTagify === 'function') {
							window.destroyCompanyDealmatchTagify();
						}
					},
				});
			}
			updateBodyScrollLock();
		});

		window.companyDrawer.on("kt.drawer.shown", function() {
			updateBodyScrollLock();

			
			// re-grab in case Livewire re-rendered it
			const drawerEl = window.companyDrawerElement || document.getElementById('kt_drawer_view_company');
			if (!drawerEl) return;

			$(drawerEl)
				.off('change.companyId')
				.on('change.companyId', '#company_company_id', function (e) {
					window.checkCompanyCompanyId(this.value, $('#company_id', drawerEl).val());
				});

			// Wait 1 second then run the line below
			setTimeout(function() {
				window.initCompanyDrawerOverviewFields();
			}, 750);
		});
	}


	
	window.currentCompanyID = 0;

	// The drawer scroll lock pins <body> with position:fixed and a negative top, so Tagify's
	// body-relative absolute coordinates land off-screen once the page has been scrolled.
	function useFixedCompanyDealmatchDropdown(tagify) {
		if (!tagify || !tagify.dropdown) {
			return;
		}
		tagify.dropdown.position = function () {
			var dropdown = tagify.DOM.dropdown;
			var anchor = tagify.DOM.input || tagify.DOM.scope;
			if (!dropdown || !anchor || !tagify.state.dropdown.visible) {
				return;
			}
			var rect = anchor.getBoundingClientRect();
			var dropdownHeight = dropdown.offsetHeight;
			var viewportHeight = document.documentElement.clientHeight;
			var placeAbove = viewportHeight - rect.bottom < dropdownHeight && rect.top > dropdownHeight;
			var top = placeAbove ? rect.top - dropdownHeight : rect.bottom - 1;

			dropdown.style.cssText = 'position: fixed; transform: none; left: ' + rect.left + 'px; width: ' + rect.width + 'px; top: ' + top + 'px;';
			dropdown.setAttribute('placement', placeAbove ? 'top' : 'bottom');
		};
		tagify.on('dropdown:show dropdown:updated', function () {
			tagify.dropdown.position();
		});
	}

	window.destroyCompanyDealmatchTagify = function () {
		if (!window.companyDealmatchTagifyInstances) {
			return;
		}
		Object.keys(window.companyDealmatchTagifyInstances).forEach(function (key) {
			var t = window.companyDealmatchTagifyInstances[key];
			if (t && typeof t.destroy === 'function') {
				try {
					t.destroy();
				} catch (e) { /* noop */ }
			}
		});
		window.companyDealmatchTagifyInstances = {};
	};

	window.initCompanyDealmatchTagify = function (root) {
		var scope = root && root.querySelector ? root : document;
		if (!scope.querySelector || !scope.querySelector('#company_drawer_property_type')) {
			return;
		}
		var leaseWhitelist = window.leaseTypeTags || window.leaseTypes;
		var classWhitelist = window.classTags || window.classes;
		if (!window.propertyTypeTags || !window.stateTags || !leaseWhitelist || !classWhitelist || !window.tenantsOfInterestTags) {
			return;
		}

		window.destroyCompanyDealmatchTagify();
		window.companyDealmatchTagifyInstances = {};

		var find = function (sel) {
			return scope.querySelector(sel);
		};

		var pt = find('#company_drawer_property_type');
		window.companyDealmatchTagifyInstances.propertyTypes = new Tagify(pt, {
			whitelist: window.propertyTypeTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99,
			},
		});

		window.didSelectAllStates = false;
		var st = find('#company_drawer_states');
		var tagifyStates = new Tagify(st, {
			whitelist: window.stateTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99,
			},
			callbacks: {
				add: function (e) {
					if (e.detail.data.value === 'Select All') {
						tagifyStates.removeTag(e.detail.tag);
						if (!window.didSelectAllStates) {
							window.didSelectAllStates = true;
							tagifyStates.addTags(window.stateTags);
						}
					}
				},
			},
		});
		window.companyDealmatchTagifyInstances.states = tagifyStates;

		var toi = find('#company_drawer_tenants_of_interest');
		window.companyDealmatchTagifyInstances.tenantsOfInterest = new Tagify(toi, {
			whitelist: window.tenantsOfInterestTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		var lt = find('#company_drawer_lease_type');
		window.companyDealmatchTagifyInstances.leaseType = new Tagify(lt, {
			whitelist: leaseWhitelist,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		var bc = find('#company_drawer_building_class');
		window.companyDealmatchTagifyInstances.buildingClass = new Tagify(bc, {
			whitelist: classWhitelist,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		var tt = find('#company_drawer_tenancy_type');
		window.companyDealmatchTagifyInstances.tenancyType = new Tagify(tt, {
			whitelist: window.tenancyTypesTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		var at = find('#company_drawer_anchor_type');
		window.companyDealmatchTagifyInstances.anchorType = new Tagify(at, {
			whitelist: window.anchorTypesTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		var ct = find('#company_drawer_cities');
		window.companyDealmatchTagifyInstances.cities = new Tagify(ct, {
			whitelist: window.cityTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		var it = find('#company_drawer_index_type');
		window.companyDealmatchTagifyInstances.indexType = new Tagify(it, {
			whitelist: window.indexTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		var rt = find('#company_drawer_rate_type');
		window.companyDealmatchTagifyInstances.rateType = new Tagify(rt, {
			whitelist: window.rateTypeTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		var lt = find('#company_drawer_loan_type');
		window.companyDealmatchTagifyInstances.loanType = new Tagify(lt, {
			whitelist: window.loanTypesTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		var at = find('#company_drawer_amortization_type');
		window.companyDealmatchTagifyInstances.amortizationType = new Tagify(at, {
			whitelist: window.amortizationTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		var pt = find('#company_drawer_prepayment_penalty_type');
		window.companyDealmatchTagifyInstances.prepaymentPenaltyType = new Tagify(pt, {
			whitelist: window.prepaymentPenaltiesTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		var rt = find('#company_drawer_recourse_type');
		window.companyDealmatchTagifyInstances.recourseType = new Tagify(rt, {
			whitelist: window.recourseTypesTags,
			valueField: 'value',
			key: 'id',
			enforceWhitelist: true,
			dropdown: {
				position: "input",
				enabled: 0,
				closeOnSelect: false,
				maxItems: 99999999,
			},
		});

		Object.keys(window.companyDealmatchTagifyInstances).forEach(function (key) {
			useFixedCompanyDealmatchDropdown(window.companyDealmatchTagifyInstances[key]);
		});
	};

	window.viewCompany = function(event, id) {                                     
		event.preventDefault();

		if(window.dealCompaniesDataTable) {
			window.dealCompaniesDataTable.draw();
		}

		if(window.contactDrawer) {
			window.contactDrawer.hide();
		}

		KTDrawer.getInstance(document.querySelector("#kt_activities"))?.hide();

		window.App.profileDrawer.load({
			storeKey: 'companyProfile',
			id: id,
			url: "/companies/getview/id/" + id,
			contentsSelector: '#company_profile_contents',
			loadingSelector: '#company_profile_loading',
			getCurrentId: function () {
				return window.currentCompanyID;
			},
			setCurrentId: function (nextId) {
				window.currentCompanyID = nextId;
			},
			resetChrome: function () {
				window.App.profileDrawer.resetCompanyChrome();
			},
			beforeFetch: function () {
				if (typeof window.destroyCompanyDealmatchTagify === 'function') {
					window.destroyCompanyDealmatchTagify();
				}
			},
			onSuccess: function () {
				if (window.activeCompanyTab) {
					window.showCompanyTab(window.activeCompanyTab);
				}
				if (typeof window.initTasksManagerFilters === 'function') {
					window.initTasksManagerFilters(document.getElementById('company_profile_contents'));
				}
				if (typeof window.initCompanyDealmatchTagify === 'function') {
					window.initCompanyDealmatchTagify(document.getElementById('company_profile_contents'));
				}
				if (typeof window.initCompanyDrawerOverviewFields === 'function') {
					window.initCompanyDrawerOverviewFields();
				}
			},
			drawer: window.companyDrawer,
		});
	}

	window.pendingCompanyNote = false;

	window.addCompanyNote = function() {

		window.addCompanyNoteButtonText = jQuery("#add_note_button").html();

		window.addSpinnerToButton(jQuery("#add_note_button"));

		var empty = false;
		if($("#company_new_note").val() == "") {
			empty = true;
		}
	
		if(empty) {
			window.toastError("Sorry, a note cannot be blank.");
			window.removeSpinnerFromButton(jQuery("#add_note_button"), window.addCompanyNoteButtonText);
			return;
		}
		
		var csrf_token = $('meta[name="csrf-token"]').attr('content');

		$.ajax({
			type: "POST",
			url: "/companies/notes/add",
			data: { 
				_token: csrf_token,
				company_id: window.currentCompanyID,
				note: $("#company_new_note").val(),
			},
			success: function (data) {
				window.toastSuccess("You have successfully added a note!");
				$("#company_new_note").val("");
				window.removeSpinnerFromButton(jQuery("#add_note_button"), window.addCompanyNoteButtonText);
				window.pendingCompanyNote = false;
				if (window.currentCompanyID && typeof window.viewCompany === 'function') {
					window.viewCompany(new Event('click'), window.currentCompanyID);
				} else if (window.companyNotesDataTable) {
					window.companyNotesDataTable.ajax.reload(null, true);
				}
			},
			error: function (data, textStatus, errorThrown) {
				window.toastError("An error occurred while adding your note. Please try again.");
				window.removeSpinnerFromButton(jQuery("#add_note_button"), window.addCompanyNoteButtonText);
				window.pendingCompanyNote = false;
			},
		});
	}

	window.unserializeFormData = function(formData) {
		var params = {};
		formData.split('&').forEach(function(pair) {
			var [key, value] = pair.split('=');
			key = decodeURIComponent(key);
			value = decodeURIComponent(value);
			if (params[key]) {
				if (Array.isArray(params[key])) {
					params[key].push(value);
				} else {
					params[key] = [params[key], value];
				}
			} else {
				params[key] = value;
			}
		});
		return params;
	}

	window.showCompanyTab = function(tab) {
		if (tab === 'properties') {
			tab = 'overview';
		}
		$(".contactviewnav").removeClass("active");
		$("#tab_company_"+tab).addClass("active");
		window.activeCompanyTab = tab;
		$(".companytab").addClass("hidden");
		$("#tab_"+tab).removeClass("hidden");
		if (tab === 'tasks' && typeof window.initTasksManagerFilters === 'function') {
			window.initTasksManagerFilters(document.getElementById('tab_tasks'));
		}
		if (tab === 'settings') {
			window.App?.companyOwner?.init?.();
			if (typeof window.initViewCompanyAutocomplete === 'function') {
				window.initViewCompanyAutocomplete();
			}
		}
		window.adjustCompanyTabDataTable(tab);
	}

	window.adjustCompanyTabDataTable = function(tab) {
		const tables = {
			overview: window.companyPropertiesDataTable,
			properties: window.companyPropertiesDataTable,
			notes: window.companyNotesDataTable,
			contacts: window.companyContactsDataTable,
			documents: window.companyFilesDataTable,
		};
		const table = tables[tab];

		if (!table || typeof table.columns !== 'function') {
			return;
		}

		window.requestAnimationFrame(function () {
			table.columns.adjust().draw(false);
		});
	};

	$("#company_profile_close, #company_profile_x_button").on("click", function() {
		if (window.companyDrawer) {
			window.companyDrawer.hide();
		}
		window.App?.drawers?.sweepOverlays?.();
	});

	$("#company_profile_save").on("click", function(event) {
		event.preventDefault();
		event.stopPropagation();

		const button = this;
		if (!window.addSpinnerToButton(button)) {
			return;
		}

		const form = document.getElementById('form_' + window.activeCompanyTab);
		if (!form) {
			window.removeSpinnerFromButton(button, 'Save Changes');
			window.toastAlert('Nothing to save on this tab.');
			return;
		}

		if (typeof form.requestSubmit === 'function') {
			form.requestSubmit();
		} else {
			jQuery(form).submit();
		}
	});

	window.addDealToSingleCompany = function(id) {
		window.companyIDs = [];
		window.companyIDs.push(id);
		$("#kt_modal_companies_tether_to_deal").modal("show");
	}

	window.addDealToSingleContact = function(id) {
		window.contactIDs = [];
		window.contactIDs.push(id);
		$("#kt_modal_contacts_tether_to_deal").modal("show");
	}

	window.tetherContacts = function () {
		$("#kt_modal_contacts_tether_to_deal").modal("show");
	}

	window.submitContactsTetherToDeal = function () {
		var dealID = $("#contacts_tether_to_deal_deal_id").val();
		var contactIDs = window.contactIDs;
		var contactIDsString = "";
		for (var i = 0; i < contactIDs.length; i++) {
			contactIDsString += contactIDs[i];
			if (i < contactIDs.length - 1) {
				contactIDsString += ",";
			}
		}
		$.ajax({
			type: "POST",
			url: "/contacts/tetherdeals",
			data: {
				_token: $('meta[name="csrf-token"]').attr('content'),
				deal_id: dealID,
				contact_ids_to_move: contactIDsString,
			},
			success: function (data) {
				if (data.success) {

					window.toastSuccess("Contacts successfully tethered");

					$("#kt_modal_contacts_tether_to_deal").modal("hide");
					window.contactsDataTable.draw();
					window.contactIDs = [];
					window.syncContactCount();
					jQuery("#selectedContactCount").text(window.contactIDs.length);
					$('#contacts_tether_to_deal_deal_id').val(null).trigger('change');

					jQuery("#kt_datatable_contact_deals").DataTable().ajax.reload(null, false);

				} else {
					window.toastError("An error occurred. Please try again later.");
				}
			},
			error: function (data, textStatus, errorThrown) {
				window.toastError("An error occurred. Please try again later.");
			},
		});
	}

	window.closeContactsTetherToDealModal = function () {
		$("#kt_modal_contacts_tether_to_deal").modal("hide"); 
	}

	$("#kt_modal_contacts_tether_to_deal").on('show.bs.modal', function() {
		jQuery("#selectedContactCount").text(window.contactIDs.length);
	});

	$("#kt_modal_contacts_tether_to_deal").on('shown.bs.modal', function() {
		$('#contacts_tether_to_deal_deal_id').select2({
			dropdownParent: $("#kt_modal_contacts_tether_to_deal"),
			minimumInputLength: 2,
			delay: 250,
			cache: true,
			dataType: 'json',
			ajax: {
				url: "/deal/search",
				dataType: 'json'
			}
		});
	});

	window.viewContact = function(event, id) {        
		event.preventDefault();
	
		// Close any open Bootstrap modals
		$('.modal.show').modal('hide');

		if(window.dealContactsDataTable) {
			window.dealContactsDataTable.draw();
		}

		KTDrawer.getInstance(document.querySelector("#kt_activities"))?.hide();

		if(window.companyDrawer) {
			window.companyDrawer.hide();
		}
		
		if(jQuery("#kt_modal_add_event").length) {
			jQuery("#kt_modal_add_event").modal('hide');
		}

		if(jQuery("#kt_modal_edit_event").length) {
			jQuery("#kt_modal_edit_event").modal('hide');
		}

		window.App.profileDrawer.load({
			storeKey: 'contactProfile',
			id: id,
			url: "/contacts/getview/id/" + id,
			contentsSelector: '#contact_profile_contents',
			loadingSelector: '#contact_profile_loading',
			getCurrentId: function () {
				return window.currentContactID;
			},
			setCurrentId: function (nextId) {
				window.currentContactID = nextId;
			},
			resetChrome: function () {
				window.App.profileDrawer.resetContactChrome();
			},
			onSuccess: function () {
				window.showContactTab(new Event('click'), window.activeContactTab);
				if (typeof window.initTasksManagerFilters === 'function') {
					window.initTasksManagerFilters(document.getElementById('contact_profile_contents'));
				}
				if (window.contactPropertyTransactionDatatable && typeof window.contactPropertyTransactionDatatable.init === 'function') {
					window.contactPropertyTransactionDatatable.init();
				}
				// Settings and Deal Match inits run lazily when user switches to those tabs
				if (window.activeContactTab === 'settings' && $('#contact_type_ids').length && !$('#contact_type_ids').hasClass('select2-hidden-accessible')) {
					if (typeof window.initContactDrawerContent === 'function') window.initContactDrawerContent();
				}
				if (window.activeContactTab === 'dealmatch' && $('#contact_drawer_property_type').length && !$('#contact_drawer_property_type').hasClass('select2-hidden-accessible')) {
					if (typeof window.initContactMatchForm === 'function') window.initContactMatchForm();
				}
				if(!window.scrollToTop) {
					let scrollableDiv = jQuery("#contact_profile_contents"); 
					scrollableDiv.scrollTop(2000);
					window.scrollToTop = true;
				}
			},
			drawer: window.contactDrawer,
		});
	}

	$("#kt_drawer_view_contact .contact_profile_close_button").on("click", function() {
		if (window.contactDrawer) {
			window.contactDrawer.hide();
		}
		window.App?.drawers?.sweepOverlays?.();
	});



	window.tetherCompanies = function () {
		$("#kt_modal_companies_tether_to_deal").modal("show");
	}

	window.submitCompaniesTetherToDeal = function () {
		var dealID = $("#companies_tether_to_deal_deal_id").val();
		var companyIDs = window.companyIDs;
		var companyIDsString = "";
		for (var i = 0; i < companyIDs.length; i++) {
			companyIDsString += companyIDs[i];
			if (i < companyIDs.length - 1) {
				companyIDsString += ",";
			}
		}
		$.ajax({
			type: "POST",
			url: "/companies/tetherdeals",
			data: {
				_token: $('meta[name="csrf-token"]').attr('content'),
				deal_id: dealID,
				company_ids_to_move: companyIDsString,
			},
			success: function (data) {
				if (data.success) {

					window.toastSuccess("Companies successfully tethered");

					$("#kt_modal_companies_tether_to_deal").modal("hide");
					window.companiesDataTable.draw();
					window.companyIDs = [];
					window.syncCompanyCount();
					jQuery("#selectedCompanyCount").text(window.companyIDs.length);
					$('#companies_tether_to_deal_deal_id').val(null).trigger('change');

					jQuery("#kt_datatable_company_properties").DataTable().ajax.reload(null, false);

				} else {
					Swal.fire({
						text: "An error occurred. Please try again later.",
						icon: "error",
						buttonsStyling: false,
						confirmButtonText: "OK",
						customClass: {
							confirmButton: "btn fw-bold btn-primary",
						}
					});
				}
			},
			error: function (data, textStatus, errorThrown) {
				Swal.fire({
					text: "An error occurred. Please try again later.",
					icon: "error",
					buttonsStyling: false,
					confirmButtonText: "OK",
					customClass: {
						confirmButton: "btn fw-bold btn-primary",
					}
				});
			},
		});
	}

	window.closeCompaniesTetherToDealModal = function () {
		$("#kt_modal_companies_tether_to_deal").modal("hide"); 
	}

	$("#kt_modal_companies_tether_to_deal").on('show.bs.modal', function() {
		jQuery("#selectedCompanyCount").text(window.companyIDs.length);
    });

	$("#kt_modal_companies_tether_to_deal").on('shown.bs.modal', function() {
		$('#companies_tether_to_deal_deal_id').select2({
			dropdownParent: $("#kt_modal_companies_tether_to_deal"),
			minimumInputLength: 2,
			delay: 250,
			cache: true,
			dataType: 'json',
			ajax: {
				url: "/deal/search",
				dataType: 'json'
			}
		});
    });


	window.showContactTab = function(event, tab) {

		$(".contactviewnav").removeClass("active");
		$("#contact_tab_contact_"+tab).addClass("active");
		window.activeContactTab = tab;
		$(".contact_tab").addClass("hidden");
		$("#contact_tab_"+tab).removeClass("hidden");
		if (tab === 'tasks' && typeof window.initTasksManagerFilters === 'function') {
			window.initTasksManagerFilters(document.getElementById('contact_tab_tasks'));
		}
		// Lazy-init tab content only when that tab is shown (avoids 8 Select2 inits on every contact open)
		if (tab === 'settings' && $('#contact_type_ids').length && !$('#contact_type_ids').hasClass('select2-hidden-accessible')) {
			if (typeof window.initContactDrawerContent === 'function') window.initContactDrawerContent();
		}
		if (tab === 'dealmatch' && $('#contact_drawer_property_type').length && !$('#contact_drawer_property_type').hasClass('select2-hidden-accessible')) {
			if (typeof window.initContactMatchForm === 'function') window.initContactMatchForm();
		}
		if (tab === 'activity' && window.currentContactID && window.App?.profileDrawer?.refreshContactDrawerActivity) {
			window.App.profileDrawer.refreshContactDrawerActivity(window.currentContactID);
		}
	}

	// One-time delegated handler for removing tags in contact drawer (Settings + Deal Match)
	if (!window._drawerTagRemoveBound) {
		window._drawerTagRemoveBound = true;
		$(document).on('click.drawerTagRemove', '[data-select-id] .drawer-tag-remove', function(e) {
			e.preventDefault();
			var $container = $(this).closest('[data-select-id]');
			var selectId = $container.data('select-id');
			var val = $(this).closest('.badge-drawer-tag').data('tag-value');
			var $sel = $('#' + selectId);
			var cur = $sel.val() || [];
			$sel.val(cur.filter(function(v) { return String(v) !== String(val); })).trigger('change');
		});
	}

	window.dealFieldValidationErrors = {};

	window.parseDealNumericValue = function(value) {
		if (value === null || value === undefined || String(value).trim() === '') {
			return null;
		}

		var cleaned = String(value).replace(/,/g, '').replace(/%/g, '').trim();
		if (cleaned === '' || cleaned === '.') {
			return null;
		}

		var num = parseFloat(cleaned);
		return isNaN(num) ? null : num;
	};

	window.formatDealDecimalValue = function(num) {
		var str = Number(num).toFixed(2);
		var parts = str.split('.');
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		return parts.join('.');
	};

	window.sanitizePercentDecimalInput = function(raw) {
		var sanitized = String(raw).replace(/[^0-9.]/g, '');

		if (sanitized.indexOf('.') !== sanitized.lastIndexOf('.')) {
			sanitized = sanitized.slice(0, sanitized.lastIndexOf('.'));
		}

		var decimalIndex = sanitized.indexOf('.');
		if (decimalIndex !== -1) {
			sanitized = sanitized.slice(0, decimalIndex + 3);
		}

		return sanitized;
	};

	window.clampPercentInput = function(input, options) {
		if (!input) {
			return;
		}

		options = options || {};
		var raw = input.value;

		if (options.decimals === true) {
			var endsWithDot = window.sanitizePercentDecimalInput(raw).endsWith('.');
			var sanitized = window.sanitizePercentDecimalInput(raw);

			if (sanitized === '' || sanitized === '.') {
				if (input.value !== sanitized) {
					input.value = sanitized;
				}
				return;
			}

			var decimalNum = parseFloat(sanitized);
			if (isNaN(decimalNum)) {
				return;
			}

			var clampedDecimal = Math.max(0, Math.min(100, decimalNum));
			var nextValue;

			if (clampedDecimal !== decimalNum) {
				nextValue = options.useCommas === false
					? clampedDecimal.toFixed(2).replace(/\.?0+$/, '')
					: window.formatDealDecimalValue(clampedDecimal);
			} else {
				nextValue = sanitized;
				if (endsWithDot && !nextValue.endsWith('.')) {
					nextValue += '.';
				}
			}

			if (input.value !== nextValue) {
				input.value = nextValue;
			}
			return;
		}

		var digits = raw.replace(/[^0-9]/g, '');
		if (digits === '') {
			if (raw !== '') {
				input.value = '';
			}
			return;
		}

		var intVal = Math.max(0, Math.min(100, parseInt(digits, 10)));
		var nextValue = String(intVal);
		if (input.value !== nextValue) {
			input.value = nextValue;
		}
	};

	window.setDealFieldValidationError = function(input, key, message) {
		window.dealFieldValidationErrors[key] = true;
		jQuery(input).addClass('hasError');

		var $msg = jQuery(input).siblings('.deal-field-validation-error');
		if (!$msg.length) {
			$msg = jQuery('<div class="deal-field-validation-error text-danger fs-8 mt-1"></div>');
			jQuery(input).after($msg);
		}

		$msg.text(message).show();
	};

	window.clearDealFieldValidationError = function(input, key) {
		delete window.dealFieldValidationErrors[key];
		jQuery(input).removeClass('hasError');
		jQuery(input).siblings('.deal-field-validation-error').hide();
	};

	window.validateDealYearBuiltNotFuture = function(input) {
		var key = 'year_built';
		var val = jQuery(input).val().trim();

		if (val === '') {
			window.clearDealFieldValidationError(input, key);
			return true;
		}

		var year = parseInt(val, 10);
		var currentYear = new Date().getFullYear();

		if (isNaN(year) || year > currentYear) {
			window.setDealFieldValidationError(input, key, 'Year built can not be in the future.');
			return false;
		}

		window.clearDealFieldValidationError(input, key);
		return true;
	};

	window.hasDealFieldValidationErrors = function() {
		return Object.keys(window.dealFieldValidationErrors).length > 0;
	};

	window.initDealPercentClamps = function() {
		var integerSelectors = [
			'#min_occupancy_pct', '#max_occupancy_pct',
			'#min_ltv', '#max_ltv',
			'#min_rate', '#max_rate',
			'#cap_range', '#occupancy_pct_range', '#ltv_range', '#rate_range',
		].join(', ');

		var decimalSelectors = '#min_cap, #max_cap, #ltv, #cap_rate, #rate';

		jQuery(document).off('input.dealPercentClamp', integerSelectors).on('input.dealPercentClamp', integerSelectors, function() {
			window.clampPercentInput(this, { decimals: false });
		});

		jQuery(document).off('input.dealPercentClamp', decimalSelectors).on('input.dealPercentClamp', decimalSelectors, function() {
			var useCommas = this.id !== 'min_cap' && this.id !== 'max_cap';
			window.clampPercentInput(this, { decimals: true, useCommas: useCommas });
		});
	};

	window.initDealYearBuiltValidator = function() {
		jQuery(document).off('blur.dealYearBuilt input.dealYearBuilt', '#year_built').on('blur.dealYearBuilt input.dealYearBuilt', '#year_built', function() {
			window.validateDealYearBuiltNotFuture(this);
		});
	};

	window.contactSettingErrors = [];

	window.addContactSettingError = function(error) {
		if(!window.contactSettingErrors.includes(error)) {
			window.contactSettingErrors.push(error);
		}
	}

	window.removeContactSettingError = function(error) {
		if(window.contactSettingErrors.includes(error)) {
			window.contactSettingErrors = window.contactSettingErrors.filter(function(item) {
				return item !== error;
			});
		}
	}

	let $container = $('#contact_profile_contents');
	let $settingsTab = $container.find('#contact_tab_settings');

	window.initExpirationTrackerColorPicker = function() {
		let palette = [
			"#C6B656", "#EB69C0", "#774085", "#669CF5", "#82ADC9", "#795548",
			"#AEBEE2", "#FD58B7", "#C7B455", "#D22C71", "#7054CB", "#2D518D",
			"#80CAFA", "#333333", "#B8AAF3", "#FB2400", "#5CC57B", "#CE414C",
			"#9155D4", "#545BD9", "#72C9C5", "#777777", "#356FD9", "#CF0DFF",
			"#387B51", "#EE7F79", "#EDA7EC", "#381F8E", "#367DB0", "#9DADBA",
			"#41A33D", "#F4D095"
		];
		if ($("#expiration_tracker_color_picker").length) {
			let initialColor = $("#expiration_tracker_color").val() || '#2961C0';
			$("#expiration_tracker_color_picker").colorPick({
				'initialColor': initialColor,
				'paletteLabel': '',
				'allowRecent': false,
				'palette': palette,
				'onColorSelected': function() {
					this.element.css({'backgroundColor': this.color, 'color': this.color});
					$("#expiration_tracker_color").val(this.color);
				}
			});
		}
		if ($("#expiration_tracker_2_color_picker").length) {
			let initialColor2 = $("#expiration_tracker_2_color").val() || '#2961C0';
			$("#expiration_tracker_2_color_picker").colorPick({
				'initialColor': initialColor2,
				'paletteLabel': '',
				'allowRecent': false,
				'palette': palette,
				'onColorSelected': function() {
					this.element.css({'backgroundColor': this.color, 'color': this.color});
					$("#expiration_tracker_2_color").val(this.color);
				}
			});
		}
	};
	
	window.initContactDrawerContent = function(){

		let $container = $('#contact_profile_contents');
		let $settingsTab = $container.find('#contact_tab_settings');

		if(!$container.length || !$settingsTab.length) {
			return;
		} else {

			if($container.length) {
				$('.hasClear').each(function() {
					const $input = $(this);
					const $clearBtn = $input.siblings('.clear_input');

					// Show or hide the clear button based on input value
					$input.on('input', function() {
						$clearBtn.toggle($(this).val().length > 0);
					});

					// Clear input when the clear button is clicked
					$clearBtn.on('click', function(e) {
						e.preventDefault();  // Prevent form submission if inside a form
						$input.val('').trigger('input').focus();
						$(this).hide();
					});

					// Initial state (show clear button if value exists on page load)
					if ($input.val().length > 0) {
						$clearBtn.show();
					}
				});
			}

			if($settingsTab.length) {

				// Sync Select2 multi-select value to the hidden JSON input.
				function syncSelect2ToJson(selectId, hiddenId, includeId) {
					var $sel = $('#' + selectId);
					if (!$sel.length || !$sel.hasClass('select2-hidden-accessible')) return;
					var data = $sel.select2('data') || [];
					var arr = data.map(function(d) {
						return includeId ? { id: d.id, value: d.text } : { value: d.id };
					});
					$('#' + hiddenId).val(JSON.stringify(arr));
				}
				window.syncContactSettingsSelect2ToJson = function() {
					syncSelect2ToJson('contact_type_ids', 'contact_type_ids_json');
					syncSelect2ToJson('group_ids', 'group_ids_json', true);
					syncSelect2ToJson('drawer_contact_tags', 'drawer_contact_tags_json');
				};

				var drawerParent = $('#kt_drawer_view_contact');
				var select2Common = { width: '100%', allowClear: true, dropdownParent: drawerParent, multiple: true, closeOnSelect: false };

				// Destroy existing Select2 to prevent duplicates
				['#contact_type_ids', '#group_ids', '#drawer_contact_tags'].forEach(function(sel) {
					var $el = $(sel);
					if ($el.length && $el.hasClass('select2-hidden-accessible')) $el.select2('destroy');
				});

				function renderSelect2Outside(selectId, containerId) {
					var data = $('#' + selectId).select2('data') || [];
					var html = data.map(function(d) {
						return '<span class="badge badge-light badge-drawer-tag me-1 mb-1 fw-normal" data-tag-value="' + $('<div>').text(d.id).html() + '">' + $('<div>').text(d.text).html() + ' <span class="drawer-tag-remove ms-1" role="button" aria-label="Remove">&times;</span></span>';
					}).join('');
					$('#' + containerId).html(html || '');
				}

				if (!window._cachedContactTypeData) window._cachedContactTypeData = (window.allContactTypes || []).map(function(name) { return { id: name, text: name }; });
				let contactTypeData = window._cachedContactTypeData;
				let contactTypeVal = ($('#contact_type_ids').attr('data-initial') || '').split(',').map(function(t) { return t.trim(); }).filter(Boolean);
				$('#contact_type_ids').select2($.extend({}, select2Common, { data: contactTypeData, placeholder: 'Add contact type...' })).val(contactTypeVal).trigger('change');
				$('#contact_type_ids').off('change.syncJson').on('change.syncJson', function() {
					syncSelect2ToJson('contact_type_ids', 'contact_type_ids_json');
					renderSelect2Outside('contact_type_ids', 'contact_type_ids_outside');
				});
				renderSelect2Outside('contact_type_ids', 'contact_type_ids_outside');

				// Group select2
				// Store initial group data in window cache object for later use
				if (!window._cachedGroupData) window._cachedGroupData = (window.contactGroupOptions || []).map(function(group) {
					return { id: String(group.id), text: group.name };
				});
				let groupData = window._cachedGroupData;
				let groupVal = ($('#group_ids').attr('data-initial') || '').split(',').map(function(t) { return t.trim(); }).filter(Boolean);
				$('#group_ids').select2($.extend({}, select2Common, { data: groupData, placeholder: 'Add group...' })).val(groupVal).trigger('change');
				$('#group_ids').off('change.syncJson').on('change.syncJson', function() {
					syncSelect2ToJson('group_ids', 'group_ids_json', true);
					renderSelect2Outside('group_ids', 'group_ids_outside');
				});
				renderSelect2Outside('group_ids', 'group_ids_outside');

				// Contact Tags select2
				// Store initial contact tags in window cache object for later use
				if (!window._cachedTagsData) window._cachedTagsData = (window.allTags || []).map(function(name) { return { id: name, text: name }; });
				let tagsData = window._cachedTagsData;
				let tagsVal = ($('#drawer_contact_tags').attr('data-initial') || '').split(',').map(function(t) { return t.trim(); }).filter(Boolean);
				function renderContactTagsOutside() { renderSelect2Outside('drawer_contact_tags', 'drawer_contact_tags_outside'); }
				$('#drawer_contact_tags').select2($.extend({}, select2Common, {
					data: tagsData,
					placeholder: 'Add tag...',
					tags: true,
					createTag: function(params) {
						let term = $.trim(params.term);
						if (!term) return null;
						return { id: term, text: term, newTag: true };
					}
				})).val(tagsVal).trigger('change');
				$('#drawer_contact_tags').off('change.syncJson').on('change.syncJson', function() {
					syncSelect2ToJson('drawer_contact_tags', 'drawer_contact_tags_json');
					renderContactTagsOutside();
				});
				renderContactTagsOutside();

				window.initContactSettingAutocomplete = function(id) {
					let element = document.getElementById('settings_street');
					if (element) {
						let autocomplete = new google.maps.places.Autocomplete(element, { types: ['geocode'] });
						google.maps.event.addListener(autocomplete, 'place_changed', window.setContactSettingAddress);
					}
				}
			
				window.setContactSettingAddress = function() {
					var place = this.getPlace();
			
					var city = '';
					var state = '';
					var zipcode = '';
					var street_number = '';
					var route = '';
			
					for (var i in place.address_components) {
						var component = place.address_components[i];
						for (var j in component.types) {  // Some types are ["country", "political"]
							switch(component.types[j]) {
								case 'street_number':
									street_number = component.long_name;
									break;
								case 'route':
									route = component.long_name;
									break;
								case 'locality':
									city = component.long_name;
									break;
								case 'administrative_area_level_1':
									state = component.short_name;
									break;
								case 'postal_code':
									zipcode = component.long_name;
									break;
							}
						}
					}
			
					$("#kt_account_profile_details_form #settings_street").val(street_number + ' ' + route);
					$("#kt_account_profile_details_form #settings_city").val(city);
					$("#kt_account_profile_details_form #settings_state").val(state).change();
					$("#kt_account_profile_details_form #settings_zip").val(zipcode);
			
				}

				window.initContactSettingAutocomplete();

				for (var i = 2; i <= 10; i++) {
					$("#kt_account_profile_details_form").find("#addEmail" + i).on("click", function() {
						var n = parseInt($(this).attr("id").replace("addEmail", ""), 10);
						$("#email" + n + "container").removeClass("hidden");
						$("#addEmail" + n + "container").addClass("hidden");
						if (n < 10) {
							$("#addEmail" + (n + 1) + "container").removeClass("hidden");
						}
					});
				}

				// Add Email Numbers
				for (var i = 2; i <= 10; i++) {
					$("#kt_account_profile_details_form").find("#addEmail" + i).on("click", function() {
						var n = parseInt($(this).attr("id").replace("addEmail", ""), 10);
						$("#email" + n + "container").removeClass("hidden");
						$("#addEmail" + n + "container").addClass("hidden");
						if (n < 10) {
							$("#addEmail" + (n + 1) + "container").removeClass("hidden");
						}
					});
				}

				// Add Phone Numbers
				for (var i = 2; i <= 10; i++) {
					$("#kt_account_profile_details_form").find("#addPhone" + i).on("click", function() {
						var n = parseInt($(this).attr("id").replace("addPhone", ""), 10);
						$("#phone" + n + "container").removeClass("hidden");
						$("#addPhone" + n + "container").addClass("hidden");
						if (n < 10) {
							$("#addPhone" + (n + 1) + "container").removeClass("hidden");
						}
					});
				}
			
				for (var i = 1; i <= 10; i++) {
					window.phoneFormatter('#contact_settings_phone_' + i);
				}
			
				$('#contact_drawer_company_id').select2({
					minimumInputLength: 2,
					delay: 250,
					cache: true,
					allowClear: true,
					placeholder: 'Select Company',
					dropdownParent: $('#kt_drawer_view_contact'),
					ajax: {
						url: "/company/search",
						dataType: 'json',
					},
				});
			
				$("#interest_level_id").select2({
					placeholder: "Select Interest Level",
					minimumResultsForSearch: Infinity,
					dropdownParent: $('#kt_drawer_view_contact')
				});
			
				var clearableElements = [
					'#contact_settings_phone_1', 
					'#contact_settings_phone_2', 
					'#contact_settings_phone_3', 
					'#contact_settings_phone_4',
					'#contact_settings_phone_5',
					'#contact_settings_phone_6',
					'#contact_settings_phone_7',
					'#contact_settings_phone_8',
					'#contact_settings_phone_9',
					'#contact_settings_phone_10',
					'#email_1', 
					'#email_2', 
					'#email_3', 
					'#email_4',
					'#email_5',
					'#email_6',
					'#email_7',
					'#email_8',
					'#email_9',
					'#email_10',
					'#settings_title', 
					'#settings_street', 
					'#settings_city', 
					'#settings_state', 
					'#settings_zip'
				];
			
				clearableElements.forEach(function(element) {
					$(element).on('input', function() {
						$(element + '_clear').toggle(!!$(this).val());
					});
			
					if($(element).val().length == 0) {
						$(element + '_clear').hide();
					}
			
					$(element + '_clear').on('click', function(e) {
						e.preventDefault();
						$(element).val('').trigger('input').focus();
						$(this).hide();
					});
				});

				$('#expiration_tracker_date').flatpickr({
					enableTime: false,
					dateFormat: "m/d/Y",
					allowInput: true,
					position: positionFlatpickrFixed,
				});

				if ($('#expiration_tracker_2_date').length) {
					$('#expiration_tracker_2_date').flatpickr({
						enableTime: false,
						dateFormat: "m/d/Y",
						allowInput: true,
						position: positionFlatpickrFixed,
					});
				}

				window.initExpirationTrackerColorPicker();

			}
	

		}
	};

	window.initContactMatchForm = function() {
		var dropdownParent = $('#kt_drawer_view_contact').length
			? $('#kt_drawer_view_contact')
			: ($('#matchForm').length ? $('#matchForm') : $('body'));
		let matchSelects = [
			{ selectId: 'contact_drawer_property_type', hiddenId: 'contact_drawer_property_type_json', outsideId: 'contact_drawer_property_type_outside', whitelist: 'propertyTypeTags', placeholder: 'Add property type...' },
			{ selectId: 'contact_drawer_states', hiddenId: 'contact_drawer_states_json', outsideId: 'contact_drawer_states_outside', whitelist: 'stateTags', placeholder: 'Add state...' },
			{ selectId: 'contact_drawer_tenants_of_interest', hiddenId: 'contact_drawer_tenants_of_interest_json', outsideId: 'contact_drawer_tenants_of_interest_outside', whitelist: 'tenantsOfInterestTags', placeholder: 'Add tenant...' },
			{ selectId: 'contact_drawer_lease_type', hiddenId: 'contact_drawer_lease_type_json', outsideId: 'contact_drawer_lease_type_outside', whitelist: 'leaseTypeTags', placeholder: 'Add lease type...' },
			{ selectId: 'contact_drawer_building_class', hiddenId: 'contact_drawer_building_class_json', outsideId: 'contact_drawer_building_class_outside', whitelist: 'classTags', placeholder: 'Add class...' },
			{ selectId: 'contact_drawer_cities', hiddenId: 'contact_drawer_cities_json', outsideId: 'contact_drawer_cities_outside', whitelist: 'cityTags', placeholder: 'Add city...' },
			{ selectId: 'contact_drawer_tenancy_type', hiddenId: 'contact_drawer_tenancy_type_json', outsideId: 'contact_drawer_tenancy_type_outside', whitelist: 'tenancyTypesTags', placeholder: 'Add tenancy type...' },
			{ selectId: 'contact_drawer_anchor_type', hiddenId: 'contact_drawer_anchor_type_json', outsideId: 'contact_drawer_anchor_type_outside', whitelist: 'anchorTypesTags', placeholder: 'Add anchor type...' },
			{ selectId: 'contact_drawer_recourse_type', hiddenId: 'contact_drawer_recourse_type_json', outsideId: 'contact_drawer_recourse_type_outside', whitelist: 'recourseTags', placeholder: 'Add recourse type...' },
			{ selectId: 'contact_drawer_amortization_type', hiddenId: 'contact_drawer_amortization_type_json', outsideId: 'contact_drawer_amortization_type_outside', whitelist: 'amortizationTags', placeholder: 'Add amortization type...' },
			{ selectId: 'contact_drawer_rate_type', hiddenId: 'contact_drawer_rate_type_json', outsideId: 'contact_drawer_rate_type_outside', whitelist: 'rateTypeTags', placeholder: 'Add rate type...' },
			{ selectId: 'contact_drawer_loan_type', hiddenId: 'contact_drawer_loan_type_json', outsideId: 'contact_drawer_loan_type_outside', whitelist: 'loanTypesTags', placeholder: 'Add loan type...' },
			{ selectId: 'contact_drawer_index_type', hiddenId: 'contact_drawer_index_type_json', outsideId: 'contact_drawer_index_type_outside', whitelist: 'indexTags', placeholder: 'Add index type...' },
			{ selectId: 'contact_drawer_prepayment_penalty_type', hiddenId: 'contact_drawer_prepayment_penalty_type_json', outsideId: 'contact_drawer_prepayment_penalty_type_outside', whitelist: 'prepaymentPenaltiesTags', placeholder: 'Add prepayment penalty type...' },
		];
		let select2MatchCommon = { width: '100%', allowClear: true, dropdownParent: dropdownParent, multiple: true, closeOnSelect: false };

		function syncMatchSelectToJson(selectId, hiddenId) {
			let $sel = $('#' + selectId);
			if (!$sel.length || !$sel.hasClass('select2-hidden-accessible')) return;
			let data = $sel.select2('data') || [];
			var arr = data.filter(function(d) { return d.id !== 'all'; }).map(function(d) { return { id: d.id, value: d.text }; });
			$('#' + hiddenId).val(JSON.stringify(arr));
		}
		function renderMatchSelectOutside(selectId, containerId) {
			let data = $('#' + selectId).select2('data') || [];
			let html = data.map(function(d) {
				let escapedId = $('<div>').text(String(d.id)).html();
				let escapedText = $('<div>').text(d.text).html();
				return '<span class="badge badge-light badge-drawer-tag me-1 mb-1 fw-normal" data-tag-value="' + escapedId + '">' + escapedText + ' <span class="drawer-tag-remove ms-1" role="button" aria-label="Remove">&times;</span></span>';
			}).join('');
			$('#' + containerId).html(html || '');
		}

		window.syncMatchFormSelect2ToJson = function() {
			matchSelects.forEach(function(m) { syncMatchSelectToJson(m.selectId, m.hiddenId); });
		};

		matchSelects.forEach(function(m) {
			let $sel = $('#' + m.selectId);
			if (!$sel.length) return;
			if ($sel.hasClass('select2-hidden-accessible')) $sel.select2('destroy');

			let tags = window[m.whitelist] || [];

			let data = tags.map(function(t) { return { id: t.id, text: t.value }; });
			let initialJson = [];
			try { initialJson = JSON.parse($('#' + m.hiddenId).val() || '[]'); } catch (e) {}
			let initialIds = initialJson.map(function(x) { return x.id; });

			$sel.select2($.extend({}, select2MatchCommon, { data: data, placeholder: m.placeholder }))
				.val(initialIds).trigger('change');
			$sel.off('change.syncMatch').on('change.syncMatch', function() {
				syncMatchSelectToJson(m.selectId, m.hiddenId);
				renderMatchSelectOutside(m.selectId, m.outsideId);
			});
			syncMatchSelectToJson(m.selectId, m.hiddenId);
			renderMatchSelectOutside(m.selectId, m.outsideId);
		});

		// States select2
		let $statesSel = $('#contact_drawer_states');
		if ($statesSel.length && $statesSel.hasClass('select2-hidden-accessible')) {
			$statesSel.off('select2:select.matchAll').on('select2:select.matchAll', function(e) {
				if (e.params.data.id === 'all') {
					let allIds = (window.stateTags || []).map(function(t) { return t.id; }).filter(function(id) { return id !== 'all'; });
					$statesSel.val(allIds).trigger('change');
				}
			});
		}

		if ($('#matchForm').length && !$('#kt_drawer_view_contact').length) {
			$('#matchForm').addClass('match-form-ready');
		}
	};

	window.comingSoon = function() {
		Swal.fire({
			title: "Coming Soon",
			icon: "warning",
			confirmButtonText: "OK",
			customClass: {
				confirmButton: 'btn-darkblue',
				timerProgressBar: 'bg-darkblue',
			},
			timer: 2000,
			timerProgressBar: true 
		});
	}

	window.toggleMap = function() {	
		if ($("#show_map_toggle").is(":checked")) {
			window.location.href = "/propertymap/map";
		} else {
			window.location.href = "/propertymap/list";
		}
	}
  
	$('#referral_contact_id').select2({
		minimumInputLength: 2,
		delay: 250,
		cache: true,
		dataType: 'json',
		ajax: {
			url: "/customer/search",
			dataType: 'json'
		}
	});

	$('#referral_contact_id').on('select2:select', function (e) {
		$('#add_referral_contact_id').val(e.params.data.id);
		$('#add_referral_contact_form').submit();
	});

	$('#kt_aside_toggle').on('click', function () {
		if (getCookie('asideState') === 'minimized') {
			jQuery("#kt_aside_menu_wrapper").removeClass("force75wide");
			document.cookie = 'asideState=maximized; expires=Thu, 01 Jan 2030 00:00:00 UTC; path=/;';
		} else {
			jQuery("#kt_aside_menu_wrapper").addClass("force75wide");

			document.cookie = 'asideState=minimized; expires=Thu, 01 Jan 2030 00:00:00 UTC; path=/;';
		}
	});
	
	function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) {
			return parts.pop().split(';').shift();
		}
	}


	let syncingDashboardDealFilter = false;

	$('.dashboardStatusFilter').on('select2:select', function (e) {
		if (syncingDashboardDealFilter) return;

		window.totalDashboardRecords = 0;

		syncingDashboardDealFilter = true;

		const value = e.params.data.id;

		$('.dashboardStatusFilter').not(this).each(function () {
			$(this).val(value).trigger('change.select2');
		});

		$.ajax({
			type: "POST",
			url: "/set_dashboard_deal_filter",
			data: {
				_token: $('meta[name="csrf-token"]').attr('content'),
				status: value
			},
			success: function(data) {
				Object.values(window.dashboardDataTables).forEach(dt => {
					dt.draw();
				});
			}
		});



		syncingDashboardDealFilter = false;
	});
			

	window.defaultNewModal = 'deal_details';
	
	window.addNewDealToPortfolio = function(buildingFloor) {
		window.defaultNewModal = 'deal_portfolio_details';
		$("#kt_modal_create_deal").modal('show');
		Livewire.dispatch('setPortfolioId', {
			portfolioId: window.portfolio_id,
			floor: buildingFloor !== undefined && buildingFloor !== null && buildingFloor !== '' ? buildingFloor : null,
		});

		KTMenu.createInstances();
		setTimeout(function() {
			KTMenu.createInstances();
		}, 500);
	}

	$("#new_deal_link, #new_deal_button").on("click", function() {
		window.defaultNewModal = 'deal_details';
		window.defaultNewDealStatusId = null;
		$("#kt_modal_create_deal").modal('show');
		window.initCreateNewDealModal();
	});

	$("#new_portfolio_link").on("click", function() {
		window.defaultNewModal = 'deal_portfolio_details';
		window.defaultNewDealStatusId = null;
		$("#kt_modal_create_deal").modal('show');
		window.initCreateNewDealModal();
	});

	$('#kt_modal_create_deal').on('show.bs.modal', function (event) {
		var statusId = window.defaultNewDealStatusId || null;
		window.defaultNewDealStatusId = null;

		Livewire.dispatch('setStepOneValue', {
			data: window.defaultNewModal,
			statusId: statusId,
		});
	});

	$(".theTaskNameDiv").click(function(e) {
		e.preventDefault();
		const taskID = $(this).parent().parent().find(".btnCompleteTask").prop("value");
		// Ensure Livewire is available
		if (typeof Livewire !== 'undefined') {
			Livewire.dispatch('loadTaskInfo', { taskId: taskID });
		} else {
			console.error('Livewire is not defined');
		}
	});

    // Instant task complete / reopen (no Yes/No confirmation)
    window.pendingTaskToggleIds = window.pendingTaskToggleIds || new Set();

    window.refreshTaskViewsAfterToggle = function () {
        Livewire.dispatch('refreshDashboardStats');
        Livewire.dispatch('refreshTaskProgress');
        Livewire.dispatch('refreshTasksList', { to: 'tasks.view-list' });
        Livewire.dispatch('refreshTasksList', { to: 'tasks.manager' });
        Livewire.dispatch('refreshTasksList', { to: 'tasks.dashboard' });
        Livewire.dispatch('refreshPipelineDatatable');
        Livewire.dispatch('refreshCompaniesDatatable');
        Livewire.dispatch('refreshContactsDatatable');
    };

    window.paintDashboardTaskToggle = function (checkbox, completing) {
        if (!checkbox || typeof checkbox.closest !== 'function') {
            return;
        }

        const row = checkbox.closest('[data-dashboard-task-row]');
        if (!row) {
            return;
        }

        row.classList.toggle('is-complete', !!completing);

        const list = row.closest('[data-dashboard-tasks]');
        const hidesCompleted = list?.getAttribute('data-hides-completed') === '1';
        const hidesOpen = list?.getAttribute('data-hides-open') === '1';
        const shouldLeave = (!!completing && hidesCompleted) || (!completing && hidesOpen);
        row.classList.toggle('is-leaving', shouldLeave);
    };

    window.showTaskToggleToast = function (completing) {
        const message = completing ? 'Task marked as complete!' : 'Task marked as incomplete!';
        if (typeof window.toastSuccess === 'function') {
            window.toastSuccess(message);
        }
    };

    window.submitTaskToggle = function (taskId, completing, checkbox) {
        const pendingKey = String(taskId);
        if (window.pendingTaskToggleIds.has(pendingKey)) {
            if (checkbox) {
                $(checkbox).prop('checked', !completing);
            }
            return;
        }

        window.pendingTaskToggleIds.add(pendingKey);
        window.paintDashboardTaskToggle(checkbox, completing);

        const toggleWrapper = checkbox ? $(checkbox).closest('[data-task-toggle]') : null;
        if (toggleWrapper) {
            toggleWrapper.addClass('is-toggling');
        }

        const csrf_token = $('meta[name="csrf-token"]').attr('content');
        $.ajax({
            type: 'POST',
            url: completing ? '/tasks/complete' : '/tasks/uncomplete',
            data: {
                _token: csrf_token,
                id: taskId,
            },
            success: function () {
                window.showTaskToggleToast(completing);
                window.refreshTaskViewsAfterToggle();
            },
            error: function (xhr) {
                const msg = xhr?.responseJSON?.error || 'An error occurred. please try again.';
                window.toastError(msg);
                if (checkbox) {
                    $(checkbox).prop('checked', !completing);
                    window.paintDashboardTaskToggle(checkbox, !completing);
                }
                if (completing && xhr?.status === 422) {
                    Livewire.dispatch('openLinkFileModal', {
                        taskId: parseInt(taskId, 10),
                        completeAfterLink: true,
                    });
                }
            },
            complete: function () {
                window.pendingTaskToggleIds.delete(pendingKey);
                if (toggleWrapper) {
                    toggleWrapper.removeClass('is-toggling');
                }
            },
        });
    };

    window.markTaskCompleted = function (taskId, requiresFile, hasLinkedFile) {
        if (requiresFile && !hasLinkedFile) {
            window.toastAlert('Link a document to complete this task.');
            Livewire.dispatch('openLinkFileModal', { taskId: taskId, completeAfterLink: true });
            return;
        }

        const checkbox = document.querySelector('.btnCompleteTask[value="' + taskId + '"]');
        if (checkbox) {
            checkbox.checked = true;
            window.btnCompleteTask(checkbox);
            return;
        }

        window.submitTaskToggle(taskId, true, null);
    };

    window.btnCompleteTask = function (checkbox) {
        const theCheckbox = $(checkbox);
        const taskID = theCheckbox.val();
        const completingTask = theCheckbox.prop('checked');
        const requiresFile = theCheckbox.attr('data-requires-file') === '1';
        const hasLinkedFile = theCheckbox.attr('data-has-linked-file') === '1';

        if (completingTask) {
            if (requiresFile && !hasLinkedFile) {
                theCheckbox.prop('checked', false);
                window.toastAlert('Link a document to complete this task.');
                Livewire.dispatch('openLinkFileModal', {
                    taskId: parseInt(taskID, 10),
                    completeAfterLink: true,
                });
                return;
            }

            window.submitTaskToggle(taskID, true, checkbox);
            return;
        }

        window.submitTaskToggle(taskID, false, checkbox);
    };

	$('#contact_profile_save').on('click', function(event) {
		event.preventDefault();

		const button = this;
		if (jQuery(button).prop('disabled') || jQuery(button).attr('data-kt-indicator') === 'on') {
			return;
		}
		if (!window.addSpinnerToButton(button)) {
			return;
		}

		if (window.contactSettingErrors.length > 0) {
			window.removeSpinnerFromButton(button, 'Save Changes');
			window.toastAlert('Please fix validation errors before saving.');
			return;
		}

		if(window.contactSettingErrors.length == 0) {

			if ($('#contact_tab_contact_settings').hasClass('active')) {
				if (typeof window.syncContactSettingsSelect2ToJson === 'function') window.syncContactSettingsSelect2ToJson();
				let formData = jQuery("#kt_account_profile_details_form").serialize();
				jQuery.ajax({
					url: jQuery("#kt_account_profile_details_form").attr('action'),
					type: jQuery("#kt_account_profile_details_form").attr('method'),
					data: formData,
					dataType: 'json',
					success: function(response) {
						window.finishSaveSpinnerAction(button, 'Save Changes', function () {
							window.toastSuccess("Contact Updated!");

							if (response && typeof response.company_id !== 'undefined') {
								window.currentContactCompanyID = response.company_id;
							}

							if (window.App?.profileDrawer?.updateContactSummaryFromSettings) {
								window.App.profileDrawer.updateContactSummaryFromSettings(response);
							}

							if (window.App?.profileDrawer?.updateContactsTableRowFromSettings) {
								window.App.profileDrawer.updateContactsTableRowFromSettings(response);
							}

							if (typeof Livewire !== 'undefined' && (!response || response.duplicates_may_have_changed !== false)) {
								Livewire.dispatch('refreshContactDuplicates');
								if (typeof window.setContactMergeStepOne === 'function') {
									window.setContactMergeStepOne();
								}
							}
						});
					},
					error: function(xhr, status, error) {
						window.finishSaveSpinnerAction(button, 'Save Changes');
						console.error('Error submitting form:', error);
						window.toastAlert('An error occurred. Please try again.');
					}
				});
			} else if( $('#contact_tab_contact_dealmatch').hasClass('active')) {
				if (typeof window.syncMatchFormSelect2ToJson === 'function') window.syncMatchFormSelect2ToJson();
				let newFormData = jQuery("#contact_tab_match_form").serialize();

				jQuery.ajax({
					type: jQuery("#contact_tab_match_form").attr('method'),
					url: jQuery("#contact_tab_match_form").attr('action'),
					data: newFormData,
					success: function (data) {
						window.finishSaveSpinnerAction(button, 'Save Changes', function () {
							window.toastSuccess("Contact Updated!");

							if (window.contactsDataTable) {
								window.contactsDataTable.draw(false);
							}
						});
					},
					error: function(xhr, status, error) {
						window.finishSaveSpinnerAction(button, 'Save Changes');
						console.error('Error submitting form:', error);
						window.toastAlert('An error occurred. Please try again.');
					}
				});
			} else {
				window.removeSpinnerFromButton(button, 'Save Changes');
				window.toastAlert('Nothing to save on this tab.');
			}
		} else {
			window.removeSpinnerFromButton(button, 'Save Changes');
		}
	});

	window.setContactOwner = function(contactID, ownerID) {
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		$.ajax({
			type: "POST",
			url: "/contacts/update_assigned_to",
			data: { 
				_token: csrf_token,
				contact_id: contactID,
				assigned_user_id: ownerID,
			},
			success: function (data) {
				window.viewContact(new Event('click'), contactID);
				if (!ownerID && window.contactsDataTable) {
					const thePage = window.contactsDataTable.page();
					window.contactsDataTable.draw();
					window.contactsDataTable.page(thePage);
				}
				window.toastSuccess(ownerID ? "Updated contact owner!" : "Removed contact owner!");
			}
		});
	}

	window.addReferralToContact = function(contactID, referralID) {
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		$.ajax({
			type: "POST",
			url: "/contacts/referral/add",
			data: { 
				_token: csrf_token,
				contact_id: contactID,
				referral_id: referralID,
			},
			success: function (data) {
				window.viewContact(new Event('click'), contactID);
				window.toastSuccess("Added referral to contact!");
			}
		});
	}

	window.removeReferralFromContact = function(contactID, referralID) {
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		$.ajax({
			type: "POST",
			url: "/contacts/referral/destroy",
			data: { 
				_token: csrf_token,
				contact_id: contactID,
				referral_id: referralID,
			},
			success: function (data) {
				window.viewContact(new Event('click'), contactID);
				window.toastSuccess("Removed referral from contact!");
			}
		});
	}

	window.setContactLeadStatus = function(contactID, status) {
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		$.ajax({
			type: "POST",
			url: "/contacts/status/set",
			data: { 
				_token: csrf_token,
				contact_id: contactID,
				lead_status_id: status,
			},
			success: function (data) {
				window.viewContact(new Event('click'), contactID);
				window.toastUpdateContactSuccess("Contact status has been updated!");
			}
		});
	}

	$(document).on('click', '#contact_profile_contents .contactLeadStatusDiv:not(.activeLeadStatus)', function() {
		var statusId = $(this).data('lead-status-id');
		if (statusId && window.currentContactID) {
			window.setContactLeadStatus(window.currentContactID, statusId);
		}
	});

	$(document).on('keydown', '#contact_profile_contents .contactLeadStatusDiv:not(.activeLeadStatus)', function(event) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			$(this).trigger('click');
		}
	});

	jQuery("#followUpCurrentContract").on("click", function() {
		$("#kt_modal_add_event").modal('show');
		jQuery("#select_contact_container").show();
		var csrf_token = $('meta[name="csrf-token"]').attr('content');

		//jQuery("#follow_up_type").val(type);
		jQuery("#follow_up_contact_id").val(window.currentContactID);

		$.ajax({
			type: "POST",
			url: "/callfollowup/details",
			data : { 
				_token: csrf_token, 
				contact_id: window.currentContactID,
			},
			success: function (data) {

				jQuery("#contact_name").html("<a href='#' onClick='window.viewContact(event, " + data.id + ")'>" + data.first_name + ' ' + data.last_name + "</a>");
				jQuery("#contact_address").html(data.street + ' ' + data.city + ', ' + data.state + ' ' + data.zip);
				jQuery("#contact_type").html(data.type);

				if(data.phone) {
					jQuery("#contact_phone").html("<a onclick='window.contactPhoneNumberClick(event, " + window.currentContactID + ", " + JSON.stringify(String(data.phone)) + ");' href='#'>" + data.phone + "</a>");
				} else {
					jQuery("#contact_phone").hide();
				}
				if(data.email) {
					jQuery("#contact_email").html("<a href='mailto:" + data.email + "'>" + data.email + "</a>");
					jQuery("#compose_to").val(data.email);
				} else {
					jQuery("#contact_email").hide();
				}

				jQuery("#contact_note").html(data.note);
				jQuery("#contact_note_date").html(data.note_date);
				jQuery("#follow_up_date").val();

				jQuery("#select_contact_container").hide();
			},
		});
	});

	jQuery("#sendDealMatchLinkCurrentContact").on("click", function() {
		if (!window.currentContactID) {
			window.toastAlert("An error occurred. please try again.");
			return;
		}

		Swal.fire({
			text: "Are you sure you want to email this contact?",
			icon: "warning",
			showCancelButton: true,
			buttonsStyling: false,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			customClass: {
				confirmButton: "btn fw-bold btn-darkblue",
				cancelButton: "btn fw-bold btn-active-light-primary"
			}
		}).then(function (result) {
			if (result.value) {
				var csrf_token = $('meta[name="csrf-token"]').attr('content');
				$.ajax({
					type: "POST",
					url: "/contacts/emailmatchingform",
					data: {
						_token: csrf_token,
						contact_ids: [window.currentContactID]
					},
					success: function (data) {
						window.toastSuccess("You have emailed the contact!");
					},
					error: function (data, textStatus, errorThrown) {
						window.toastAlert("An error occurred. please try again.");
					},
				});
			}
		});
	});

	jQuery("#deleteCurrentContact").on("click", function() {
		if (!window.App || typeof window.App.confirmBulkDelete !== 'function') {
			return;
		}
		window.App.confirmBulkDelete({
			entity: 'contacts',
			count: 1,
			onConfirm: function () {
				var theUrl = "/contacts/destroy/id/" + window.currentContactID;
				var csrf_token = $('meta[name="csrf-token"]').attr('content');
				$.ajax({
					type: "POST",
					url: theUrl,
					data: { _token: csrf_token },
					success: function (data) {
						Livewire.dispatch('refreshContactGroupCount');

						window.toastSuccess("You have deleted the contact!");

						if (window.contactsDataTable) {
							const thePage = window.contactsDataTable.page();
							window.contactsDataTable.draw();
							window.contactsDataTable.page(thePage);
						}
						window.contactDrawer.hide();
						window.currentContactID = 0;
					},
					error: function (data, textStatus, errorThrown) {
						window.toastError("An error occurred. please try again.");
					},
				});
			}
		});
	});

	window.initLeadStatusColorPickers = function() {
		$(".contactLeadStatusPicker").each(function () {
			var $this = $(this); // Current div
			var thisID = $this.attr("id").replace("addColorPicker", "");
			var initialColor = jQuery("#kt_modal_statuses_add_html_color" + thisID).val();
				$this.colorPick({
				'initialColor': initialColor,
				'paletteLabel': '',
				'allowRecent': false,
				'palette': [
					"#C6B656", "#EB69C0", "#774085", "#669CF5", "#82ADC9", "#795548", 
					"#AEBEE2", "#FD58B7", "#C7B455", "#D22C71", "#7054CB", "#2D518D", 
					"#80CAFA", "#333333", "#B8AAF3", "#FB2400", "#5CC57B", "#CE414C", 
					"#9155D4", "#545BD9", "#72C9C5", "#777777", "#356FD9", "#CF0DFF", 
					"#387B51", "#EE7F79", "#EDA7EC", "#381F8E", "#367DB0", "#9DADBA", 
					"#41A33D", "#F4D095"
				],
				'onColorSelected': function () {
					this.element.css({ 'backgroundColor': this.color, 'color': this.color });
					jQuery("#kt_modal_statuses_add_html_color" + thisID).val(this.color);
				}
			});
		});
	}

	window.getLeadStatusNameCounts = function() {
		var counts = {};

		$('#kt_modal_edit_lead_statuses .lead-status-row__name').each(function() {
			var value = $(this).val().trim();

			if (value === '') {
				return;
			}

			var key = value.toLowerCase();
			counts[key] = (counts[key] || 0) + 1;
		});

		return counts;
	};

	window.markDuplicateLeadStatuses = function() {
		var counts = window.getLeadStatusNameCounts();

		$('#kt_modal_edit_lead_statuses .lead-status-row').each(function() {
			var $row = $(this);
			var value = $row.find('.lead-status-row__name').val().trim();
			var isDuplicate = value !== '' && (counts[value.toLowerCase()] || 0) > 1;

			$row.toggleClass('is-duplicate', isDuplicate);
		});
	};

	window.hasDuplicateLeadStatuses = function() {
		return Object.values(window.getLeadStatusNameCounts()).some(function(count) {
			return count > 1;
		});
	};

	window.initLeadStatusSortable = function() {
		if (typeof window.Sortable === 'undefined') {
			return;
		}

		var sortableElement = document.getElementById('sortable-list');
		if (!sortableElement) {
			return;
		}

		if (typeof window.Sortable.get === 'function') {
			var existing = window.Sortable.get(sortableElement);
			if (existing) {
				existing.destroy();
			}
		}

		window.Sortable.create(sortableElement, {
			handle: '.drag-handle',
			animation: 150,
			onEnd: function() {
				var itemOrder = Array.from(sortableElement.children)
					.filter(function(item) { return item.dataset && item.dataset.id; })
					.map(function(item) { return item.dataset.id; });

				fetch('/contacts/updateContactStatusSortOrder', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
						'Accept': 'application/json'
					},
					body: JSON.stringify({ order: itemOrder })
				})
				.then(function(response) { return response.json(); })
				.then(function(data) {
					if (!data.success) {
						console.error('Failed to update order');
					}
				})
				.catch(function(error) {
					console.error('Error:', error);
				});
			}
		});
	}

	$("#kt_modal_edit_lead_statuses").on("show.bs.modal", function() {
		window.initLeadStatusColorPickers();
		window.initLeadStatusSortable();
		window.markDuplicateLeadStatuses();
	});

	$("#kt_modal_edit_lead_statuses_cancel").on("click", function() {
		$("#kt_modal_edit_lead_statuses").modal('hide');
	});

    $("#kt_modal_edit_lead_statuses_submit").on("click", function(event) {
        event.preventDefault();

		var $submitButton = $(this);

		if ($submitButton.prop('disabled') || $submitButton.attr('data-kt-indicator') === 'on') {
			return;
		}

		// Remove any empty new lead statuses.
		$('#sortable-list input[name*="lead_statuses[NEW"]').each(function() {
			if ($(this).val() === '') {
				$(this).closest('.lead-status-row').remove();
			}
		});

		window.markDuplicateLeadStatuses();

		if (window.hasDuplicateLeadStatuses()) {
			window.toastError('Each lead status must have a unique name.');
			return;
		}

        var formData = $("#editLeadStatusForm").serialize();

		if (!window.addSpinnerToButton($submitButton)) {
			return;
		}

        $.ajax({
            url: $("#editLeadStatusForm").attr("action"),
            method: $("#editLeadStatusForm").attr("method") || "POST",
            data: formData,
            success: function(response) {
				$.ajax({
					type: "GET",
					url: "/contacts/getleadstatuses",
					success: function (data) {
						$(".leadStatusDynamicDiv").html(data);
						window.initLeadStatusColorPickers();
						window.initLeadStatusSortable();
						if(window.currentContactID > 0) {
							window.viewContact(new Event('click'), window.currentContactID);
						}
						window.toastSuccess("Lead Statuses Updated!");
						$("#kt_modal_edit_lead_statuses").modal('hide');
						window.finishSaveSpinnerAction($submitButton, 'Save');
					},
					error: function() {
						window.finishSaveSpinnerAction($submitButton, 'Save');
						window.toastError("An error occurred while refreshing lead statuses.");
					}
				});
            },
            error: function(xhr, status, error) {
                console.error("Error submitting form:", error);
				var message = xhr.responseJSON && xhr.responseJSON.message
					? xhr.responseJSON.message
					: "An error occurred while submitting the form.";
				window.toastError(message);
				window.finishSaveSpinnerAction($submitButton, 'Save');
            }
        });
    });
	window.closeNewDealModal = function() {
		$('#kt_modal_create_deal').modal('hide');		
	}

	window.viewDealEmbedFile = function(id) {
		$("#preview_file_iframe").attr("src", "/getfileembed/id/" + id);
		$("#kt_modal_view_file").modal("show");
	}

	window.doClaimContact = function(contactID) {

		$.ajax({
			type: "GET",
			url: "/contacts/claim/id/" + contactID,
			success: function (data) {
				window.viewContact(new Event('click'), contactID);
				window.toastSuccess("Contact claimed!");
			}
		});
	}

	document.addEventListener('dealOwnerUpdated', event => {
		window.toastSuccess("Deal owner updated!");
	});

	document.addEventListener('portfolioOwnerUpdated', event => {
		window.toastSuccess("Portfolio owner updated!");
	});

	document.addEventListener('livewire:setCompanyDetails', (event) => {
		const { id, name } = event.detail;	
		const $portfolioCompany = $('#portfolio_company');

		if ($portfolioCompany.is('select')) {
			const newOption = new Option(name, id, true, true);
			$portfolioCompany.append(newOption).trigger('change');
		}
	});

	jQuery("#btn_portfolio_import").on("click", function() {
		jQuery("#kt_modal_portfolio_import").modal('show');
	});


	window.verifyPortfolioPropertyRemove = function(index) {
		Swal.fire({
			text: "Are you sure you want to remove this property?",
			icon: "warning",
			showCancelButton: true,
			buttonsStyling: false,
			reverseButtons: true,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			customClass: {
				confirmButton: "btn fw-bold btn-red",
				cancelButton: "btn fw-bold btn-gray"
			}
		}).then(function (result) {
			if (result.value) {
				Livewire.dispatch('removePortfolioProperty', { index: index });
			}
		});
	}

    window.deletePortfolioDeal = function (dealID) {
        if (!window.App || typeof window.App.confirmBulkDelete !== 'function') {
            return;
        }
        window.App.confirmBulkDelete({
            entity: 'deals',
            count: 1,
            onConfirm: function () {
				$.ajax({
					type: "POST",
					url: "/deals/delete/id/" + dealID,
					data: {
						_token: $('meta[name="csrf-token"]').attr('content'),
					},
					success: function (response) {
						window.toastSuccess("Deal deleted successfully!");
						window.location.reload();
					},
					error: function (data, textStatus, errorThrown) {
						window.toastError("An error occurred. Please try again later.");
					},
				});
            }
        });
    }


	$(document).on('click', function (e) {
		// Check if the click is NOT inside an active .contactMergeMiddleTd or input
		if (
			!$(e.target).closest('.contactMergeMiddleTd').length &&
			!$(e.target).is('.theEditField') &&
			$('.theEditField').length // only run if an edit field is actually showing
		) {
			Livewire.dispatch('clearEditField');
		}
	});

	window.setContactMergeStepOne = function() {
		// Defer one frame so Livewire morph finishes and three-dots menus exist in the DOM.
		requestAnimationFrame(function () {
			window.KTMenu?.createInstances?.();
		});
	}

	document.addEventListener('duplicatesRefreshed', () => {
		window.setContactMergeStepOne();
	});

	// Livewire re-renders Step 1 (back from Step 2, search, select-all) without always
	// re-running createInstances — rebind KTMenu when this component commits.
	document.addEventListener('livewire:init', () => {
		if (!window.Livewire || typeof window.Livewire.hook !== 'function') {
			return;
		}

		Livewire.on('toast-success', (payload) => {
			const message = payload?.message ?? payload?.[0]?.message ?? 'Success';
			window.toastSuccess(message);
		});
		Livewire.on('toast-error', (payload) => {
			const message = payload?.message ?? payload?.[0]?.message ?? 'An error occurred.';
			window.toastError(message);
		});

		window.Livewire.hook('commit', ({ component, succeed }) => {
			succeed(() => {
				const name = component?.name || component?.fingerprint?.name || '';
				const el = component?.el;
				const isMergeDuplicates =
					name === 'modals.contacts.merge-duplicates' ||
					el?.closest?.('#kt_modal_resolve_duplicate_contacts');

				if (!isMergeDuplicates) {
					return;
				}

				window.setContactMergeStepOne();
			});
		});
	});

	document.addEventListener('contactMergeCompleted', function (event) {
		window.toastSuccess("Contacts have been merged successfully!");
		window.contactsDataTable.draw();

		var detail = event.detail || [];
		var payload = Array.isArray(detail) ? (detail[0] || {}) : detail;

		if (!payload.fromIndex) {
			return;
		}

		jQuery(".dt_contact_id").prop("checked", false);
		jQuery("#selectAllContacts").prop("checked", false);
		window.contactIDs = [];
		if (typeof window.syncContactCount === "function") {
			window.syncContactCount();
		}
	});

	document.addEventListener('setDuplicateCount', (event) => {
		var duplicateCount = event.detail[0].count;

		if(duplicateCount >= 50) {
			jQuery("#resolveDuplicatesCount").html("(50+)");
		}  else {
			jQuery("#resolveDuplicatesCount").html("(" + duplicateCount + ")");
		}

		if(duplicateCount > 0) {
			jQuery("#resolve_duplicates_btn").show();
		} else {
			jQuery("#resolve_duplicates_btn").hide();
		}

	});


	jQuery("#kt_modal_resolve_duplicate_contacts").on("show.bs.modal", function() {	
		window.setContactMergeStepOne();
		window.phoneFormatter(".phoneEdit");

		if (window.App && window.App.pendingContactMerge) {
			var pending = window.App.pendingContactMerge;
			window.App.pendingContactMerge = null;

			if (pending.adhoc) {
				window.Livewire.dispatch("confirmAdhocContactMerge", {
					contactIds: pending.contactIds,
				});
			}

			return;
		}

		window.Livewire.dispatch('resetMergeIds');
		window.Livewire.dispatch('initStepOne');
	});

	document.addEventListener('openContactMergeFromIndex', function () {
		window.App = window.App || {};
		window.App.pendingContactMerge = { skipInit: true };
		jQuery("#kt_modal_resolve_duplicate_contacts").modal("show");
	});

	document.addEventListener('requestAdhocContactMergeConfirm', function (event) {
		var detail = event.detail || [];
		var payload = Array.isArray(detail) ? (detail[0] || {}) : detail;
		var contactIds = payload.contactIds || [];

		if (!window.App || typeof window.App.confirmModal !== 'function') {
			window.toastError('Confirmation is unavailable. Please refresh the page.');
			return;
		}

		window.App.confirmModal({
			title: 'Merge Contacts',
			body: 'These contacts are not a detected duplicate group. Merge them anyway?',
			confirmText: 'Merge',
			cancelText: 'Cancel',
			onConfirm: function () {
				window.App.pendingContactMerge = {
					contactIds: contactIds,
					adhoc: true,
				};
				jQuery("#kt_modal_resolve_duplicate_contacts").modal("show");
			},
		});
	});

	document.addEventListener('requestClusterSubsetMergeConfirm', function (event) {
		var detail = event.detail || [];
		var payload = Array.isArray(detail) ? (detail[0] || {}) : detail;
		var contactIds = payload.contactIds || [];

		if (!window.App || typeof window.App.confirmModal !== 'function') {
			window.toastError('Confirmation is unavailable. Please refresh the page.');
			return;
		}

		window.App.confirmModal({
			title: 'Larger Duplicate Group Found',
			body: 'These contacts are part of a larger duplicate group. The full group will be shown for merging.',
			confirmText: 'Continue Merge',
			cancelText: 'Cancel',
			onConfirm: function () {
				window.Livewire.dispatch('confirmClusterMergeFromIndex', {
					contactIds: contactIds,
				});
			},
		});
	});

	window.resolveCurrentContactDuplicate = function() {
		jQuery("#kt_modal_resolve_duplicate_contacts").show();
	};


	window.pinContactNote = function(theID) {
		if(window.numPinnedNotes >= 5) {
			window.toastError("You can pin up to 5 notes. Please unpin a note first.");
			return;
		}

		window.blockElementWithMsg("#kt_datatable_deal_notes", "Pinning note...");

		$.ajax({
			type: "GET",
			url: "/notes/contact/pin/" + window.currentContactID + "/" + theID,
			success: function(data) {
				window.viewContact(new Event('click'), window.currentContactID);
				window.toastSuccess("Note pinned!");
				window.numPinnedNotes++;
			},
			error: function() {
				window.toastError("An error occurred. please try again.");
			}
		});
	}

	window.unpinContactNote = function(theID) {

		window.blockElementWithMsg("#kt_datatable_deal_notes", "Unpinning note...");

		$.ajax({
			type: "GET",
			url: "/notes/contact/unpin/" + window.currentContactID + "/" + theID,
			success: function(data) {
				window.viewContact(new Event('click'), window.currentContactID);
				window.toastSuccess("Note unpinned!");
				window.numPinnedNotes--;
			},
			error: function() {
				window.toastError("An error occurred. please try again.");
			}
		});
	}


	window.pinCompanyNote = function(theID) {
		if(window.numPinnedNotes >= 5) {
			window.toastError("You can pin up to 5 notes. Please unpin a note first.");
			return;
		}

		window.blockElementWithMsg("#kt_company_notes_datatable_wrapper", "Pinning note...");

		$.ajax({
			type: "GET",
			url: "/notes/company/pin/" + window.currentCompanyID + "/" + theID,
			success: function(data) {
				window.companyNotesDataTable.ajax.reload(null, true);
				window.toastSuccess("Note pinned!");
				window.numPinnedNotes++;
				window.releaseElement("#kt_company_notes_datatable_wrapper");
			},
			error: function() {
				window.toastError("An error occurred. please try again.");
			}
		});
	}

	window.unpinCompanyNote = function(theID) {

		window.blockElementWithMsg("#kt_company_notes_datatable_wrapper", "Unpinning note...");

		$.ajax({
			type: "GET",
			url: "/notes/company/unpin/" + window.currentCompanyID + "/" + theID,
			success: function(data) {
				window.companyNotesDataTable.ajax.reload(null, true);
				window.toastSuccess("Note unpinned!");
				window.numPinnedNotes--;
				window.releaseElement("#kt_company_notes_datatable_wrapper");
			},
			error: function() {
				window.toastError("An error occurred. please try again.");
			}
		});
	}

	window.deleteTaskDashboard = function(id) {
		if (!window.App || typeof window.App.confirmModal !== 'function') {
			if (typeof window.toastError === 'function') {
				window.toastError('Confirmation is unavailable. Please refresh the page.');
			}
			return;
		}

		var shown = window.App.confirmModal({
			title: 'Delete Task',
			subtitle: '',
			body: 'Are you sure you want to delete this task?',
			confirmText: 'Confirm Delete',
			cancelText: 'Cancel',
			confirmClass: 'btn-red',
			onConfirm: function () {
				Livewire.dispatch('removeTaskFromDashboardList', { taskId: id });

				setTimeout(function() {
					window.toastSuccess("You have successfully deleted this task!");
					Livewire.dispatch('refreshDashboardStats');
					Livewire.dispatch('refreshTaskProgress');
				}, 500);
			},
		});

		if (shown !== true) {
			return;
		}
	}

	window.deleteTask = function(id) {
		if (!window.App || typeof window.App.confirmModal !== 'function') {
			if (typeof window.toastError === 'function') {
				window.toastError('Confirmation is unavailable. Please refresh the page.');
			}
			return;
		}

		var shown = window.App.confirmModal({
			title: 'Delete Task',
			subtitle: '',
			body: 'Are you sure you want to delete this task?',
			confirmText: 'Confirm Delete',
			cancelText: 'Cancel',
			confirmClass: 'btn-red',
			onConfirm: function () {
				var csrf_token = $('meta[name="csrf-token"]').attr('content');
				$.ajax({
					type: "POST",
					url: "/tasks/delete",
					data: {
						_token: csrf_token,
						id: id
					},
					success: function () {
						window.toastSuccess("You have successfully deleted this task!");
						Livewire.dispatch('refreshDashboardStats');
						Livewire.dispatch('refreshTaskProgress');
						Livewire.dispatch('refreshTasksList', { to: 'tasks.view-list' });
						Livewire.dispatch('refreshTasksList', { to: 'tasks.manager' });
						Livewire.dispatch('refreshTasksList', { to: 'tasks.dashboard' });
						Livewire.dispatch('refreshPipelineDatatable');
						Livewire.dispatch('refreshCompaniesDatatable');
						Livewire.dispatch('refreshContactsDatatable');
					},
					error: function (xhr) {
						const msg = xhr?.responseJSON?.error || "An error occurred. please try again.";
						window.toastError(msg);
					}
				});
			},
		});

		if (shown !== true) {
			return;
		}
	}

	window.newDealToContact = function() {
		window.defaultNewModal = 'deal_details';
		
		$("#kt_modal_create_deal").modal('show');
		window.initCreateNewDealModal();

		Livewire.dispatch('addContactToDeal', { contactId: window.currentContactID });

		KTMenu.createInstances();
		setTimeout(function() {
			KTMenu.createInstances();
		}, 500);
	}

	window.tetherDealToContact = function() {
		alert("Tether Deal to Contact - Coming Soon");
	}

	window.newContactToCompany = function() {
		window.setNewContactCompany(window.currentCompanyID, jQuery("#divCurrentCompanyName").html());
		jQuery("#kt_modal_add_contact").modal('show');
	}

	window.tetherContactToCompany = function() {
		if (! window.currentCompanyID) {
			window.toastError("No company selected.");
			return;
		}

		Livewire.dispatch('setCompanyAddContactModalCompany', { companyId: window.currentCompanyID });
		jQuery("#kt_modal_company_add_contact").modal('show');
	}

	if ($('#add_company_contact_id').length) {
		window.addCompanyContactSelect = $('#add_company_contact_id').select2({
			dropdownParent: $("#kt_modal_company_add_contact"),
			minimumInputLength: 2,
			delay: 250,
			cache: true,
			dataType: 'json',
			ajax: {
				url: "/contact/search",
				dataType: 'json'
			}
		});

		window.addCompanyContactSelect.on('change', function() {
			if (! window.currentCompanyID) {
				window.toastError("No company selected.");
				return;
			}

			var csrf_token = $('meta[name="csrf-token"]').attr('content');

			$.ajax({
				type: "POST",
				url: "/companies/contacts/add/id/" + window.currentCompanyID,
				data: {
					_token: csrf_token,
					contact_id: jQuery("#add_company_contact_id").val(),
				},
				success: function (data) {
					if (data == "exists") {
						window.toastError("This contact is already associated with the company.");
					} else if (data == "contact_not_found" || data == "company_not_found") {
						window.toastError("An error occurred. Please try again.");
					} else {
						window.toastSuccess("Contact added to company!");
						Livewire.dispatch('refreshCompanyAddContactModalList');

						if (window.companyContactsDataTable) {
							window.companyContactsDataTable.ajax.reload(null, false);
						}

						jQuery("#add_company_contact_id").val(null).trigger('change.select2', { suppress: true });

						if (typeof window.reloadMenus === 'function') {
							window.reloadMenus();
						}
					}
				},
				error: function () {
					window.toastError("An error occurred. Please try again.");
				},
			});
		});

		$("#kt_modal_company_add_contact_submit").on('click', function(event) {
			event.preventDefault();
			jQuery("#kt_modal_company_add_contact").modal('hide');
		});
	}

	window.removeContactFromCompany = function(event, theCompanyId, theContactId) {
		event.preventDefault();

		if (! theCompanyId || ! theContactId) {
			window.toastError("An error occurred. Please try again.");
			return;
		}

		Swal.fire({
			text: "Are you sure you want to remove this contact from the company?",
			icon: "warning",
			showCancelButton: true,
			buttonsStyling: false,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			reverseButtons: true,
			customClass: {
				confirmButton: "btn fw-bold btn-danger",
				cancelButton: "btn fw-bold btn-active-light-primary"
			}
		}).then(function (result) {
			if (! result.value) {
				return;
			}

			var csrf_token = $('meta[name="csrf-token"]').attr('content');

			$.ajax({
				type: "POST",
				url: "/companies/contacts/destroy",
				data: {
					_token: csrf_token,
					company_id: theCompanyId,
					contact_id: theContactId,
				},
				success: function (data) {
					if (data == "contact_not_found" || data == "not_associated") {
						window.toastError("An error occurred. Please try again.");
						return;
					}

					window.toastSuccess("You have removed a contact from this company.");
					Livewire.dispatch('refreshCompanyAddContactModalList');

					if (window.companyContactsDataTable) {
						window.companyContactsDataTable.ajax.reload(null, false);
					}

					if (typeof window.reloadMenus === 'function') {
						window.reloadMenus();
					}

					window.KTMenu?.createInstances?.();
				},
				error: function () {
					window.toastError("An error occurred. Please try again.");
				},
			});
		});
	}

	window.initIndicatorStepper = function() {

		const stepperNav = document.querySelector('#kt_modal_create_deal #createDealContainer .stepper-nav');
		const indicatorStepperItem = stepperNav ? stepperNav.querySelector('#indicator-stepper-item') : null;		
		
		if (!stepperNav || !indicatorStepperItem) {
			console.log('Indicator stepper item not found');
			return;
		}

		const stepperItems = stepperNav.querySelectorAll('.stepper-item');
		let currentItem = stepperNav.querySelector('.stepper-item.current');

		// Find the item with "current" class - THIS WAS MISSING!
		stepperItems.forEach(item => {
			if(item.classList.contains('current')) {
				currentItem = item;
			}
		});

		if (currentItem) {
			const navRect = stepperNav.getBoundingClientRect();
			const currentRect = currentItem.getBoundingClientRect();
			const leftPosition = currentRect.left - navRect.left;
			const width = currentRect.width;
			indicatorStepperItem.style.setProperty('left', leftPosition + 'px', 'important');
			indicatorStepperItem.style.setProperty('width', width + 'px', 'important');
		}

		// Add click handlers for all stepper items
		stepperItems.forEach(item => {
			if (!item.hasAttribute('data-indicator-listener')) {
				item.setAttribute('data-indicator-listener', 'true');
				item.addEventListener('click', function() {
					const navRect = stepperNav.getBoundingClientRect();
					const itemRect = this.getBoundingClientRect();
					indicatorStepperItem.style.left = (itemRect.left - navRect.left) + 'px';
					indicatorStepperItem.style.width = itemRect.width + 'px';
				});
			}
		});

	};

	window.initCreateNewDealModal = function() {
		window.initCreateNewDealAutocomplete();
		window.initCreateNewPortfolioAutocomplete();

		document.addEventListener('initCreatePortfolioMenus', function () {
			KTMenu.createInstances();
			setTimeout(function() {
				KTMenu.createInstances();
			}, 500);
		});

		const $portfolioCompany = $('#portfolio_company');

		if ($portfolioCompany.is('select')) {
			$portfolioCompany.select2({
				dropdownParent: $('#kt_modal_create_deal'),
				minimumInputLength: 2,
				delay: 250,
				cache: true,
				dataType: 'json',
				ajax: {
					url: "/company/search",
					dataType: 'json'
				}
			});
		}


		const $portfolioPropertyContact = $('#portfolio_property_contact_id');

		if ($portfolioPropertyContact.is('select')) {
			$portfolioPropertyContact.select2({
				dropdownParent: $('#kt_modal_create_deal'),
				minimumInputLength: 2,
				delay: 250,
				cache: true,
				dataType: 'json',
				ajax: {
					url: "/contact/search",
					dataType: 'json'
				}
			});
		}

		const $portfolioPropertyCompany = $('#portfolio_property_company_id');

		if ($portfolioPropertyCompany.is('select')) {
			$portfolioPropertyCompany.select2({
				dropdownParent: $('#kt_modal_create_deal'),
				minimumInputLength: 2,
				delay: 250,
				cache: true,
				dataType: 'json',
				ajax: {
					url: "/company/search",
					dataType: 'json'
				}
			});
		}

		$("#start_date").flatpickr({
			enableTime: false,
			dateFormat: "m/d/Y",
		}); 

		$("#deadline_date").flatpickr({
			enableTime: false,
			dateFormat: "m/d/Y",
		});   


		$("#portfolio_start_date").flatpickr({
			enableTime: false,
			dateFormat: "m/d/Y",
		}); 

		$("#portfolio_deadline_date").flatpickr({
			enableTime: false,
			dateFormat: "m/d/Y",
		});   

		$("#portfolio_property_start_date").flatpickr({
			enableTime: false,
			dateFormat: "m/d/Y",
		}); 

		$("#portfolio_property_deadline_date").flatpickr({
			enableTime: false,
			dateFormat: "m/d/Y",
		});  

	}

	if ($.fn.DataTable && $('#dt_admin_custom_attributes').length) {
		$('#dt_admin_custom_attributes').DataTable({
			responsive: true,
			pageLength: 25,
			columnDefs: [{ orderable: false, targets: -1 }]
			,
			drawCallback: function() {
				var searchElement = jQuery("#dt_admin_custom_attributes_filter");

				// Find header inside #id_content_container > .card > .card-header
				var header = jQuery("#kt_content_container")
					.find(".card")
					.first()
					.find(".card-header");

				// Add or reuse toolbar
				var toolbar = header.find(".card-toolbar");
				if (toolbar.length === 0) {
					toolbar = jQuery('<div class="card-toolbar customattributetoolbar"></div>').appendTo(header);
				}

				// Move search element into that toolbar
				toolbar.append(searchElement);
			}
		});
	}
});

window.decodeHtml = function(html) {
	var txt = document.createElement('textarea');
	txt.innerHTML = html;
	return txt.value;
}

let scheduleDate = $('#schedule-date');

scheduleDate.on("click", function(){
	if(scheduleDate.val()) {
		$('.set_schedule_btn_confirm').disabled = false;
	} else {
		$('.set_schedule_btn_confirm').disabled = true;
	}
});

$('.set_schedule_btn').on('click', function(e){
	$(scheduleDate).flatpickr({
		enableTime: false,
		dateFormat: "m/d/Y",
	});

	$('.set_schedule_btn_container').hide();
	$('.set_schedule_content').show();	
});

$('.cancel_schedule_btn').on('click', function(e){
	scheduleDate.val('');
	$('.set_schedule_btn_container').show();
	$('.set_schedule_content').hide();
	
});

$('.remove_schedule_btn').on('click', function(e){
	scheduleDate.val('');
	$('.set_schedule_btn_container').show();
	$('.set_schedule_content').hide();
	$('.set_schedule_values_container').hide();
	
});

$('.edit_schedule_btn').on('click', function(e){
	$('.set_schedule_content').show();
	$('.set_schedule_values_container').hide();
	
});

$('.set_schedule_btn_confirm').on('click', function(e){
	if (!scheduleDate.val()) {

		$(".set_schedule_date_email_error").show();

		return false;

	} else {
		jQuery(".set_schedule_date_email_error").hide();
		$('.set_schedule_values_container').show();
		$('.set_schedule_content').hide();
		$('#set-date').html(scheduleDate.val());
		$('#set-time').html($('#schedule-hour').val() + ':' + $('#schedule-min').val());
	}
});

window.viewMap = function () {

	window.mapDrawerElement = document.querySelector("#kt_drawer_view_map");
	
	document.body.appendChild(window.mapDrawerElement);
	
	window.mapDrawer = KTDrawer.getInstance(window.mapDrawerElement);
	window.mapDrawer.show();
	window.lockBodyScroll(true);

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			window.closeMapFilterDrawer();
		}
	});
}

window.closeMapFilterDrawer = function () {
	window.mapDrawerElement = document.querySelector("#kt_drawer_view_map");
	window.mapDrawer = KTDrawer.getInstance(window.mapDrawerElement);
	window.mapDrawer.hide();
	window.lockBodyScroll(false);

	if (typeof window.removePropertyMapApplySpinner === 'function') {
		window.removePropertyMapApplySpinner();
	}
}

window.resetFilterAndCloseDrawers = function () {
	location.reload();
}

/**
 * Returns a Promise resolving to the recipient whitelist for broadcast Tagify fields.
 * Lightweight base list (all / groups / tags / users). Contacts are loaded via
 * bindBroadcastTagifyContactSearch() as the user types.
 * Results are cached per page load; concurrent calls share one in-flight request.
 */
window.getBroadcastWhitelist = function () {
	if (Array.isArray(window.__broadcastWhitelistCache)) {
		return Promise.resolve(window.__broadcastWhitelistCache);
	}
	if (window.__broadcastWhitelistPromise) {
		return window.__broadcastWhitelistPromise;
	}
	window.__broadcastWhitelistPromise = new Promise(function (resolve) {
		$.ajax({
			url: '/broadcast/whitelist',
			type: 'GET',
			dataType: 'json',
			success: function (data) {
				window.__broadcastWhitelistCache = Array.isArray(data) ? data : [];
				window.__broadcastWhitelistPromise = null;
				resolve(window.__broadcastWhitelistCache);
			},
			error: function () {
				window.__broadcastWhitelistPromise = null;
				window.__broadcastWhitelistCache = [];
				console.error('Failed to load /broadcast/whitelist');
				resolve(window.__broadcastWhitelistCache);
			},
		});
	});
	return window.__broadcastWhitelistPromise;
}

/**
 * Merge contact search results into a Tagify whitelist as the user types (2+ chars).
 * Keeps the base groups/tags/users list intact.
 */
window.bindBroadcastTagifyContactSearch = function (tagify) {
	if (!tagify || tagify.__broadcastContactSearchBound) {
		return;
	}

	tagify.__broadcastContactSearchBound = true;
	var request = null;
	var debounceId = null;
	var latestQuery = '';

	var cancelInFlight = function () {
		if (debounceId) {
			clearTimeout(debounceId);
			debounceId = null;
		}
		if (request && typeof request.abort === 'function') {
			request.abort();
		}
		request = null;
	};

	tagify.on('input', function (e) {
		var value = String(e.detail.value || '').trim();
		latestQuery = value;

		// Below the search threshold: stop any pending/in-flight contact lookup and
		// let Tagify keep showing local group/tag/user matches on its own.
		if (value.length < 2) {
			cancelInFlight();
			tagify.loading(false);
			return;
		}

		// Local suggestions (groups/tags/users) render immediately; the remote
		// contact search is debounced and merged in when it returns.
		cancelInFlight();

		debounceId = setTimeout(function () {
			debounceId = null;
			var query = value;

			tagify.loading(true);

			request = $.ajax({
				url: '/broadcast/whitelist/search',
				type: 'GET',
				dataType: 'json',
				data: { q: query },
				success: function (data) {
					// Ignore responses for stale keystrokes.
					if (query !== latestQuery) {
						return;
					}

					var existing = Array.isArray(tagify.settings.whitelist) ? tagify.settings.whitelist.slice() : [];
					var byKey = {};

					existing.forEach(function (item) {
						if (item && item.value !== undefined) {
							byKey[String(item.type) + ':' + String(item.value)] = item;
						}
					});

					(Array.isArray(data) ? data : []).forEach(function (item) {
						if (item && item.value !== undefined) {
							byKey[String(item.type) + ':' + String(item.value)] = item;
						}
					});

					tagify.settings.whitelist = Object.keys(byKey).map(function (key) {
						return byKey[key];
					});

					tagify.loading(false).dropdown.show(query);
				},
				error: function (xhr) {
					if (xhr && xhr.statusText === 'abort') {
						return;
					}
					if (query === latestQuery) {
						tagify.loading(false);
					}
				},
				complete: function () {
					request = null;
				},
			});
		}, 200);
	});
}

// Warm slim whitelist on pages that include the broadcast modal so first open feels instant.
$(function () {
	if (document.querySelector('#kt_modal_broadcast')) {
		window.getBroadcastWhitelist().catch(function () {});
	}

	if (typeof window.initDealPercentClamps === 'function') {
		window.initDealPercentClamps();
	}

	if (typeof window.initDealYearBuiltValidator === 'function') {
		window.initDealYearBuiltValidator();
	}
});


window.App = window.App || {};

window.App.importProgressTracker = (function () {
	function readCookie(name) {
		try {
			const value = document.cookie
				.split('; ')
				.find(row => row.startsWith(name + '='))
				?.split('=')[1];

			return value ? JSON.parse(decodeURIComponent(value)) : null;
		} catch (error) {
			console.error('Error reading import progress cookie:', error);
			return null;
		}
	}

	function writeCookie(name, value) {
		document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + '; path=/; SameSite=Lax';
	}

	function clearCookie(name) {
		document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; max-age=0; SameSite=Lax';
	}

	function escapeHtml(value) {
		return $('<div>').text(String(value || '')).html();
	}

	function create(options) {
		let interval = null;
		let toast = null;
		let sessionId = null;
		let dismissed = false;
		let terminal = false;
		let consecutiveFailures = 0;
		let startedAt = 0;
		const queueWaitNoticeMs = 15000;

		const stickyToastOptions = {
			closeButton: true,
			debug: false,
			newestOnTop: true,
			progressBar: false,
			positionClass: 'toast-bottom-right',
			preventDuplicates: false,
			showDuration: '150',
			hideDuration: '150',
			timeOut: 0,
			extendedTimeOut: 0,
			tapToDismiss: false,
			showMethod: 'fadeIn',
			hideMethod: 'fadeOut',
			toastClass: 'importProgressToast',
		};

		function buildMessage(progress) {
			const total = Number(progress.total_records || 0);
			const processed = Number(progress.processed_records || 0);
			const percentage = Math.max(0, Math.min(100, Number(progress.percentage || 0)));

			if (total < 1) {
				const waitingForQueue = progress.status === 'pending' && Date.now() - startedAt > queueWaitNoticeMs;
				const label = waitingForQueue
					? 'Waiting for the import queue to start...'
					: 'Preparing ' + options.entityLabel + ' import...';

				return '<div class="fw-bold">' + label + '</div>' +
					'<div class="import-progress-track mt-2"><span style="width: 4%"></span></div>';
			}

			return '<div class="fw-bold">' + options.activeVerb + ' <strong>' + processed + '</strong> of <strong>' + total +
				'</strong> ' + options.entityLabel + '.</div>' +
				'<div class="d-flex align-items-center gap-2 mt-2">' +
				'<div class="import-progress-track flex-grow-1"><span style="width: ' + percentage + '%"></span></div>' +
				'<span class="fw-bold">' + percentage + '%</span></div>';
		}

		function removeToast() {
			if (toast) {
				toastr.clear(toast);
				toast = null;
			}
		}

		function renderToast(progress) {
			if (dismissed) {
				return;
			}

			if (!toast) {
				toast = toastr.info(buildMessage(progress), '', stickyToastOptions);
				toast.on('click', '.toast-close-button', function () {
					if (terminal) {
						return;
					}

					dismissed = true;
					writeCookie(options.cookieName, { session_id: sessionId, dismissed: true });
					toast = null;
				});
				return;
			}

			toast.find('.toast-message').html(buildMessage(progress));
		}

		function stopPolling(forgetSession) {
			if (interval) {
				clearInterval(interval);
				interval = null;
			}
			removeToast();
			if (forgetSession) {
				clearCookie(options.cookieName);
			}
		}

		function finish(progress) {
			terminal = true;
			stopPolling(true);
			options.onTerminal?.(progress);

			const hasRecordFailures = options.alertOnRecordFailures && Number(progress.failed_records || 0) > 0;
			const hasFailure = progress.status === 'failed' || hasRecordFailures;
			const terminalOptions = {
				closeButton: hasFailure,
				progressBar: !hasFailure,
				positionClass: 'toast-bottom-right',
				timeOut: hasFailure ? 0 : 5000,
				extendedTimeOut: hasFailure ? 0 : 1000,
				toastClass: 'importProgressToast',
			};

			if (progress.status === 'failed') {
				toastr.error(escapeHtml(progress.error_message || options.failedMessage), '', terminalOptions);
			} else if (hasRecordFailures) {
				const message = progress.error_message || options.completedWithFailuresMessage?.(progress) || options.failedMessage;
				toastr.error(escapeHtml(message), '', terminalOptions);
			} else {
				toastr.success(options.completedMessage(progress), '', terminalOptions);
			}
		}

		function poll() {
			$.ajax({
				type: 'GET',
				url: options.progressUrl(sessionId),
				success: function (progress) {
					consecutiveFailures = 0;
					options.onProgress?.(progress);
					renderToast(progress);

					if (progress.status === 'completed' || progress.status === 'failed') {
						finish(progress);
					}
				},
				error: function (xhr) {
					if (xhr.status === 404 || xhr.status === 403) {
						stopPolling(true);
						return;
					}

					consecutiveFailures++;
					if (consecutiveFailures >= 15) {
						stopPolling(false);
						toastr.error('Import status is temporarily unavailable. Progress will resume after a page reload.');
					}
				},
			});
		}

		return {
			start: function (newSessionId, state) {
				stopPolling(false);
				sessionId = newSessionId;
				dismissed = Boolean(state?.dismissed);
				terminal = false;
				consecutiveFailures = 0;
				startedAt = Date.now();
				writeCookie(options.cookieName, { session_id: sessionId, dismissed: dismissed });

				if (!dismissed) {
					renderToast({ total_records: 0, processed_records: 0, percentage: 0 });
				}

				poll();
				interval = setInterval(poll, 2000);
			},
			resume: function () {
				const state = readCookie(options.cookieName);
				if (state?.session_id) {
					this.start(state.session_id, state);
				}
			},
		};
	}

	return { create: create };
})();

window.App.adminImportProgressTracker = window.App.importProgressTracker.create({
	cookieName: 'cre_import_session',
	entityLabel: 'records',
	activeVerb: 'Importing',
	progressUrl: sessionId => '/admin/dataimporter/progress/' + sessionId,
	failedMessage: 'Import failed.',
	completedMessage: () => 'Import finished successfully.',
	onProgress: function (progress) {
		$('#importedCount').html(progress.imported_records || 0);
		$('#duplicatesNotImportedCount').html(progress.failed_records || 0);
	},
});

window.App.contactImportProgressTracker = window.App.importProgressTracker.create({
	cookieName: 'cre_contact_import_session',
	entityLabel: 'contacts',
	activeVerb: 'Importing',
	progressUrl: sessionId => '/contactimport/progress/' + sessionId,
	failedMessage: 'Contact import failed.',
	alertOnRecordFailures: true,
	completedWithFailuresMessage: function (progress) {
		return Number(progress.failed_records || 0) + ' contact rows failed. Check the spreadsheet mappings and values, then import again.';
	},
	completedMessage: function (progress) {
		return 'Successfully imported ' + Number(progress.imported_records || 0) + ' contacts. ' +
			Number(progress.skipped_records || 0) + ' skipped; ' + Number(progress.failed_records || 0) + ' failed.';
	},
	onProgress: function (progress) {
		$('#importedContactsCount').html(progress.imported_records || 0);
		$('#duplicatesNotImportedCount').html(progress.skipped_records || 0);
	},
	onTerminal: function (progress) {
		if (progress.status === 'completed' && window.contactsDataTable) {
			window.contactsDataTable.ajax.reload(null, false);
		}
	},
});

window.startImportProgressToast = function (sessionId) {
	window.App.adminImportProgressTracker.start(sessionId);
};

window.startContactImportProgress = function (sessionId) {
	window.App.contactImportProgressTracker.start(sessionId);
};

window.App.adminImportProgressTracker.resume();
window.App.contactImportProgressTracker.resume();

$(document).on('click', '#contact_drawer_add_note_button', function(e) {
    e.preventDefault();

	// Add spinner and disable button.
	let button = this;
	window.addSpinnerToButton(button);

    var noteValue = jQuery("#contact_new_note").val();
    if (noteValue) noteValue = noteValue.trim();
    if (!noteValue) {
        jQuery("#contact_new_note").addClass('hasError');
        if (jQuery("#contact_add_note_error").length === 0) {
            jQuery("#contact_drawer_dealnoteform").append('<div id="contact_add_note_error" class="text-danger mt-1">Field is blank. Add a note.</div>');
        }
        jQuery("#contact_new_note").focus();
		window.removeSpinnerFromButton(button);
        return;
    }
    jQuery("#contact_new_note").removeClass('hasError');
    jQuery("#contact_add_note_error").remove();
    var formData = jQuery("#contact_drawer_dealnoteform").serialize();
    jQuery.ajax({
        url: jQuery("#contact_drawer_dealnoteform").attr('action'),
        type: jQuery("#contact_drawer_dealnoteform").attr('method'),
        data: formData,
        success: function(response) {
			setTimeout(() => {
				window.viewContact(new Event('click'), window.currentContactID);
				window.toastSuccess("Contact Note Added!");
				window.removeSpinnerFromButton(button);
			}, 1000);
        },
        error: function(xhr, status, error) {
            console.error('Error submitting form:', error);
			window.removeSpinnerFromButton(button);
        }
    })

});

$(document).on('submit', '#contact_drawer_dealnoteform', function(e) {
    e.preventDefault();
    jQuery("#contact_drawer_add_note_button").trigger('click');
});

window.contactPhoneNumberClick = function(e, contactId, phone) {
	e.preventDefault();
	$.ajax({
		type: "POST",
		url: "/contacts/log-phone-call",
		data: {
			_token: $('meta[name="csrf-token"]').attr('content'),
			contact_id: contactId,
		},
		success: function(response) {
		},
		error: function(xhr, status, error) {
		}
	});
	window.location.href = 'tel:' + phone;
}

window.companyPhoneNumberClick = function(e, companyId, phone) {
	e.preventDefault();
	$.ajax({
		type: "POST",
		url: "/companies/log-phone-call",
		data: {
			_token: $('meta[name="csrf-token"]').attr('content'),
			company_id: companyId,
		},
		success: function(response) {
		},
		error: function(xhr, status, error) {
		}
	});
	window.location.href = 'tel:' + phone;
}

window.toggleValue = function(theID) {
	var theValue = jQuery("#column_filter_"+theID).val();
	
	if(theValue == "1") {
		jQuery("#column_filter_"+theID).val("0");
	} else {
		jQuery("#column_filter_"+theID).val("1");
	}
}

window.handleSelectChange = function(element, attributeId, objectType, objectId) {
	const value = element.value;

	$.ajax({
		type: 'POST',
		url: '/save-custom-attribute-select',
		data: {
			_token: $('meta[name="csrf-token"]').attr('content'),
			value: value,
			attribute_id: attributeId,
			object_type: objectType,
			object_id: objectId,
		},
		success: function () {
			window.toastSuccess('Custom attribute updated successfully!');
			if (window.companiesDataTable) {
				window.companiesDataTable.ajax.reload(null, false);
			}
			if (window.contactsDataTable) {
				window.contactsDataTable.ajax.reload(null, false);
			}
		},
		error: function (xhr) {
			const message = xhr.responseJSON?.message || 'Error saving custom attribute.';
			window.toastError(message);
		},
	});
};

window.handleSelectAction = function(element, attributeId, objectType, objectId) {

	let value = element.value;

	$.ajax({
		type: "POST",
		url: "/log-custom-attribute-action",
		data: {
			_token: $('meta[name="csrf-token"]').attr('content'),
			value: value,
			attribute_id: attributeId,
			object_type: objectType,
			object_id: objectId,
		},
		success: function(response) {
			window.toastSuccess("Custom attribute action logged successfully!");
		},
		error: function(xhr, status, error) {
			window.toastError("Error logging custom attribute action: " + error);
		}
	});

	// Refresh the DataTables
	if (window.contactsDataTable) {
		window.contactsDataTable.ajax.reload(null, false);
	}

	if (window.companiesDataTable) {
		window.companiesDataTable.ajax.reload(null, false);
	}

	if (window.statusDataTables) {
		for (const key in window.statusDataTables) {
			console.log('Reloading status data table: ' + key);
			if (window.statusDataTables.hasOwnProperty(key)) {
				window.statusDataTables[key].ajax.reload(null, false);
			}
		}
	}
}

if ($('#matchForm').length && !$('#kt_drawer_view_contact').length && typeof window.initContactMatchForm === 'function') {
	window.initContactMatchForm();
}